unit dashboard.maintenance;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCGridCell,
  VCL.TMSFNCGridOptions, XData.Web.Client, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCCustomGrid, VCL.TMSFNCGridDatabaseAdapter, VCL.TMSFNCCustomControl,
  VCL.TMSFNCCustomScrollControl, VCL.TMSFNCGridData, VCL.TMSFNCGrid,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls, Data.DB,
  WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.Buttons,
  System.Variants, WEBLib.DBCtrls, Vcl.Imaging.GIFImg, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer,
  VCL.TMSFNCDataGridDatabaseAdapter, VCL.TMSFNCDataGrid;

type
  TfrmDashBoardMaintenance = class(TForm)
    pTop: TPanel;
    pBottom: TPanel;
    pMain: TPanel;
    wcYears: TXDataWebClient;
    wdsYears: TXDataWebDataSet;
    dsYears: TDataSource;
    wcMonths: TXDataWebClient;
    wdsMonths: TXDataWebDataSet;
    dsMonths: TDataSource;
    wdsMonthsMonth: TIntegerField;
    wdsMonthsMonthName: TStringField;
    wdsYearsSelected: TBooleanField;
    wdsMonthsSelected: TBooleanField;
    wdsYearsYear: TIntegerField;
    pMainTop: TPanel;
    pMainMonths: TPanel;
    WebLabel2: TLabel;
    gMonths: TTMSFNCGrid;
    gdaMonths: TTMSFNCGridDatabaseAdapter;
    pMainYears: TPanel;
    WebLabel1: TLabel;
    gYears: TTMSFNCGrid;
    gdaYears: TTMSFNCGridDatabaseAdapter;
    pRegNo: TPanel;
    WebLabel3: TLabel;
    WebButton1: TButton;
    btnRegClear: TSpeedButton;
    wcReg: TXDataWebClient;
    wdsReg: TXDataWebDataSet;
    dsReg: TDataSource;
    wdsRegReg: TStringField;
    wdsRegFleetNo: TStringField;
    wdsRegFleetType: TStringField;
    wdsRegSelected: TBooleanField;
    WebTimer1: TTimer;
    wdsRegPriKey: TIntegerField;
    wdsTempReg: TXDataWebDataSet;
    StringField1: TStringField;
    StringField2: TStringField;
    StringField3: TStringField;
    BooleanField1: TBooleanField;
    IntegerField1: TIntegerField;
    pMaintTypes: TPanel;
    gSysTypes: TTMSFNCGrid;
    dsSysTypes: TDataSource;
    gdaSysTypes: TTMSFNCGridDatabaseAdapter;
    wcSysTypes: TXDataWebClient;
    wdsSysTypes: TXDataWebDataSet;
    wdsSysTypesSelected: TBooleanField;
    gReg: TTMSFNCGrid;
    gdaReg: TTMSFNCGridDatabaseAdapter;
    WebLabel4: TLabel;
    pCostGroups: TPanel;
    gCostGroups: TTMSFNCGrid;
    gdaCostGroups: TTMSFNCGridDatabaseAdapter;
    WebLabel5: TLabel;
    wdsCostGroups: TXDataWebDataSet;
    dsCostGroups: TDataSource;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    wcCostGroups: TXDataWebClient;
    wdsSysTypesSysType: TIntegerField;
    wdsSysTypesDescription: TStringField;
    wdsCostGroupsDescription: TStringField;
    wdsCostGroupsselected: TBooleanField;
    wdsDashboardSums: TXDataWebDataSet;
    wdsDashData: TXDataWebDataSet;
    wcDashboardSums: TXDataWebClient;
    dsDashBoardSums: TDataSource;
    wcDashData: TXDataWebClient;
    dsDashData: TDataSource;
    wpDashSums: TPanel;
    pDashData: TPanel;
    gDashData: TTMSFNCGrid;
    gdaDashData: TTMSFNCGridDatabaseAdapter;
    wpTotalCost: TPanel;
    WebDBLabel1: TDBLabel;
    WebLabel6: TLabel;
    wpMaintenance: TPanel;
    WebLabel7: TLabel;
    WebDBLabel2: TDBLabel;
    wpTyres: TPanel;
    wpCost: TPanel;
    wpInsurance: TPanel;
    wpOperational: TPanel;
    WebDBLabel5: TDBLabel;
    WebDBLabel3: TDBLabel;
    WebDBLabel4: TDBLabel;
    WebDBLabel6: TDBLabel;
    WebLabel8: TLabel;
    WebLabel9: TLabel;
    WebLabel10: TLabel;
    WebLabel11: TLabel;
    wdsDashboardSumsMaintenanceCost: TStringField;
    wdsDashboardSumsTyreCost: TStringField;
    wdsDashboardSumsWashCost: TStringField;
    wdsDashboardSumsInsuranceCost: TStringField;
    wdsDashboardSumsOtherCost: TStringField;
    wdsDashboardSumsTotalCost: TStringField;
    wdsDashDataJobcardNo: TIntegerField;
    wdsDashDataStockDescription: TStringField;
    wdsDashDataTotalExcl: TStringField;
    wdsDashDataGlCode: TStringField;
    wdsDashDataReason: TStringField;
    wdsDashDataCategory: TStringField;
    wdsDashDataRepMain: TStringField;
    wdsDashDataCostDescription: TStringField;
    wdsDashDataTRegNo: TStringField;
    wdsDashDataTFleetNo: TStringField;
    wdsDashDataOrderNo: TStringField;
    wdsDashDataJobDate: TStringField;
    wdsDashDataReferenceNo: TStringField;
    wdsDashDataVehType: TStringField;
    wdsDashDataJobType: TStringField;
    WebWaitMessage1: TWaitMessage;
    wbSearch: TButton;
    wpCapex: TPanel;
    wpUnAll: TPanel;
    WebLabel13: TLabel;
    WebLabel14: TLabel;
    WebDBLabel7: TDBLabel;
    WebDBLabel8: TDBLabel;
    wdsDashboardSumsCapexCost: TStringField;
    wdsDashboardSumsUnallCost: TStringField;
    WebDBLabel9: TDBLabel;
    WebDBLabel10: TDBLabel;
    WebDBLabel11: TDBLabel;
    WebDBLabel12: TDBLabel;
    WebDBLabel13: TDBLabel;
    WebDBLabel14: TDBLabel;
    WebDBLabel15: TDBLabel;
    WebDBLabel16: TDBLabel;
    WebPanel1: TPanel;
    WebLabel12: TLabel;
    WebLabel15: TLabel;
    WebLabel16: TLabel;
    wdsCostGroupsCost: TIntegerField;
    wdsDashDataSupplier: TStringField;
    btnMonthsClear: TSpeedButton;
    btnYearsClear: TSpeedButton;
    wbExcel: TButton;
    wdsDashboardSumsTotalCPK: TStringField;
    wdsDashboardSumsMaintenanceCPK: TStringField;
    wdsDashboardSumsTyreCPK: TStringField;
    wdsDashboardSumsWashCPK: TStringField;
    wdsDashboardSumsInsuranceCPK: TStringField;
    wdsDashboardSumsOtherCPK: TStringField;
    wdsDashboardSumsCapexCPK: TStringField;
    wdsDashboardSumsUnallCPK: TStringField;
    wpNoLink: TPanel;
    WebLabel17: TLabel;
    WebDBLabel17: TDBLabel;
    wdsDashboardSumsNotLinkedCost: TStringField;
    wdsDashboardSumsNotLinkedCPK: TStringField;
    WebDBLabel18: TDBLabel;
    procedure gYearsGetCellLayout(Sender: TObject; ACol, ARow: Integer;
      ALayout: TTMSFNCGridCellLayout; ACellState: TTMSFNCGridCellState);
    procedure gMonthsGetCellLayout(Sender: TObject; ACol, ARow: Integer;
      ALayout: TTMSFNCGridCellLayout; ACellState: TTMSFNCGridCellState);
    procedure WebFormShow(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
    procedure gRegGetCellLayout(Sender: TObject; ACol, ARow: Integer;
      ALayout: TTMSFNCGridCellLayout; ACellState: TTMSFNCGridCellState);
    procedure btnRegClearClick(Sender: TObject);
    procedure wdsYearsAfterPost(DataSet: TDataSet);
    procedure wdsMonthsAfterPost(DataSet: TDataSet);
    procedure WebTimer1Timer(Sender: TObject);
    procedure wdsSysTypesAfterPost(DataSet: TDataSet);
    procedure gSysTypesGetCellLayout(Sender: TObject; ACol, ARow: Integer;
      ALayout: TTMSFNCGridCellLayout; ACellState: TTMSFNCGridCellState);
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure wdsCostGroupsAfterPost(DataSet: TDataSet);
    procedure gCostGroupsGetCellLayout(Sender: TObject; ACol, ARow: Integer;
      ALayout: TTMSFNCGridCellLayout; ACellState: TTMSFNCGridCellState);
    procedure wbSearchClick(Sender: TObject);
    procedure wdsDashboardSumsAfterOpen(DataSet: TDataSet);
    procedure wdsDashDataAfterOpen(DataSet: TDataSet);
    procedure gDashDataSortFormat(Sender: TObject; Col: Integer;
      var SortFormat: TTMSFNCGridSortFormat; var APrefix, ASuffix: string);
    procedure btnMonthsClearClick(Sender: TObject);
    procedure btnYearsClearClick(Sender: TObject);
    procedure gMonthsCellClick(Sender: TObject; ACol, ARow: Integer);
    procedure gYearsCellClick(Sender: TObject; ACol, ARow: Integer);
    procedure gRegCellClick(Sender: TObject; ACol, ARow: Integer);
    procedure gSysTypesCellClick(Sender: TObject; ACol, ARow: Integer);
    procedure gCostGroupsCellClick(Sender: TObject; ACol, ARow: Integer);
    procedure wbExcelClick(Sender: TObject);
    procedure CallMaintReport(sFilename, sReport : String);
    procedure WebButton2Click(Sender: TObject);
  private
    { Private declarations }
    procedure DoRegInfo;
    procedure TriggerTimer;


  public
    { Public declarations }
    procedure DoLoadYears;
    procedure DoLoadMonths;
    procedure DoLoadSystemTypes;
    procedure DoLoadCostGroups;
    procedure DoLoadMainData;
    Procedure DoLoadMainDataDetails;

    //procedure downloadxlsx(Report : String; iParam : Integer; Param1, Param2, Param3, Param4, Param5, Param6, Param7, Param8, Param9, Param10 : JSValue);
    [Async]
    procedure downloadfile(Report, sFileName : String; Param : Array of JSValue); async;
  protected procedure LoadDFMValues; override; end;

  TTMSFNCGridDataBaseAdapterOpen = class(TTMSFNCGridDataBaseAdapter);

var
  frmDashBoardMaintenance: TfrmDashBoardMaintenance;

implementation

{$R *.dfm}

uses
  stfmssystem.connection,
  share.common,
  share.classes;

{ TfrmDashBoardMaintenance }

procedure TfrmDashBoardMaintenance.downloadfile(Report, sFileName : String; Param : Array of JSValue);
  var
    filesize,
    I, ArrayCount : Integer;
    AB : TJSArrayBuffer;
    AV : TJSUInt8Array;

    Client : TXDataWebClient;
    Response : TXDataClientResponse;
    FileData : WideString;

    DirectDownload : TDirectDownload;


    FileName : string;
begin
  filesize := -1;
  Client            := TXDataWebClient.Create(nil);
  Client.Connection := dmdata.dbConnect;

  // Get File
  try
    Response := await(Client.RawInvokeAsync(Report, Param));
  except
    on Error: Exception do
    begin
      Client.Free;
      console.log('ERROR: '+Error.Classname+' ('+Error.Message+')+ ');
      exit;
    end;
  end;

  DirectDownload := TDirectDownload.Create;
  DirectDownload := TDirectDownload(Response.Result);

  // Convert file
  try
    FileName := string(DirectDownload.Filename);
    asm FileData = window.atob(DirectDownload.Data); end;

    filesize := Length(FileData);
  except on E: Exception do
    begin
      console.log('ERROR: (Base64) File could not be decoded');
      raise Exception.Create('ERROR: (Base64) File could not be decoded');
    end;
  end;

  if (filesize <> -1) then
  begin
    console.log('Retrieved (Base64) File: '+IntToStr(length(FileData))+' bytes');
    console.log('Decoded (Base64) File: '+IntToStr(filesize)+' bytes');
  end;

  Client.Free;

  if (filesize <> -1) then
    begin
      AB := TJSArrayBuffer.new(filesize);
      AV := TJSUInt8Array.new(AB);
      for i := 0 to filesize - 1 do
        AV[i] := TJSString(FileData).charCodeAt(i);
      Application.DownloadBinaryFile(AV, sFilename);
    end
  else
    begin
      // what/how do you want to tell the user about a failure here
    end;
  DirectDownload.Free;
end;

procedure TfrmDashBoardMaintenance.btnRegClearClick(Sender: TObject);
begin
  wdsReg.DisableControls;
  wdsReg.First;
  Repeat
    If wdsReg.FieldByName('Selected').asBoolean then
      begin
        wdsReg.Edit;
        wdsReg.FieldByName('Selected').asBoolean := False;
        wdsReg.Post;
      end;
    wdsReg.Next;
  Until wdsReg.Eof;
  wdsReg.First;
  wdsReg.EnableControls;
end;

procedure TfrmDashBoardMaintenance.btnYearsClearClick(Sender: TObject);
begin
  wdsYears.DisableControls;
  wdsYears.First;
  Repeat
    If wdsYears.FieldByName('Selected').asBoolean then
      begin
        wdsYears.Edit;
        wdsYears.FieldByName('Selected').asBoolean := False;
        wdsYears.Post;
      end;
    wdsYears.Next;
  Until wdsYears.Eof;
  wdsYears.First;
  wdsYears.EnableControls;
end;

procedure TfrmDashBoardMaintenance.DoLoadMainData;
  procedure OnResult(Response : TXDataClientResponse);
  begin
    wdsDashboardSums.Close;
    wdsDashboardSums.SetJsonData(Response.Result);
    wdsDashboardSums.Open;

  end;

begin
  wcDashboardSums.RawInvoke('IdashboardService.GetJobcardTypeTotals', [GetJsonArrayFromDataSet(wdsYears,true,'Selected'),
                                                                       GetJsonArrayFromDataSet(wdsMonths,true,'Selected'),
                                                                       GetJsonArrayFromDataSet(wdsReg,true,'Selected'),
                                                                       GetJsonArrayFromDataSet(wdsSysTypes,true,'Selected'),
                                                                       GetJsonArrayFromDataSet(wdsCostGroups,true,'Selected')], @OnResult);
end;

procedure TfrmDashBoardMaintenance.DoLoadMainDataDetails;
  procedure OnResult(Response : TXDataClientResponse);
  begin
    wdsDashData.Close;
    wdsDashData.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    wdsDashData.Open;
  end;

begin
  wcDashData.RawInvoke('IdashboardService.GetJobcardDetails', [GetJsonArrayFromDataSet(wdsYears,true,'Selected'),
                                                               GetJsonArrayFromDataSet(wdsMonths,true,'Selected'),
                                                               GetJsonArrayFromDataSet(wdsReg,true,'Selected'),
                                                               GetJsonArrayFromDataSet(wdsSysTypes,true,'Selected'),
                                                               GetJsonArrayFromDataSet(wdsCostGroups,true,'Selected')], @OnResult);
end;

procedure TfrmDashBoardMaintenance.DoLoadMonths;
  procedure OnResultMonths(Response : TXDataClientResponse);
  begin
    wdsMonths.Close;
    wdsMonths.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    wdsMonths.Open;
    DoLoadSystemTypes;
  end;

begin
  wcMonths.RawInvoke('IdashboardService.GetMonths', [4], @OnResultMonths);
end;

procedure TfrmDashBoardMaintenance.DoLoadYears;
  procedure OnResultYears(Response : TXDataClientResponse);
  begin
    wdsYears.Close;
    wdsYears.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    wdsYears.Open;
    DoLoadMonths;
  end;
begin
  wcYears.RawInvoke('IdashboardService.GetYears', [4], @OnResultYears);

end;

procedure TfrmDashBoardMaintenance.DoLoadSystemTypes;
  procedure OnResultSysTypes(Response : TXDataClientResponse);
  begin

    wdsSysTypes.Close;
    wdsSysTypes.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    wdsSysTypes.Open;
    DoLoadCostGroups;
  end;
begin
  wcSysTypes.RawInvoke('IdashboardService.GetSysTypes', [], @OnResultSysTypes);

end;

procedure TfrmDashBoardMaintenance.DoLoadCostGroups;
  procedure OnResultSysTypes(Response : TXDataClientResponse);
  begin

    wdsCostGroups.Close;
    wdsCostGroups.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    wdsCostGroups.Open;
  end;
begin
  wcSysTypes.RawInvoke('IdashboardService.GetJobCostDesc', [], @OnResultSysTypes);

end;


procedure TfrmDashBoardMaintenance.DoRegInfo;
  procedure OnResult(Response : TXDataClientResponse);
    var
      iLastKey : Integer;
      iCurrentKey : Integer;
  begin
    If not wdsReg.Active then
      begin
        wdsReg.Close;
        wdsReg.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsReg.Open;
      end
    else
      begin
        wdsTempReg.Close;
        wdsTempReg.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsTempReg.Open;

        iCurrentKey := wdsReg.FieldByName('PriKey').asInteger;
        wdsReg.DisableControls;
        wdsTempReg.First;
        iLastKey := -1;
        Repeat
          If not wdsReg.Locate('PriKey', wdsTempReg.FieldByName('PriKey').asInteger,[]) then
            begin
              If iLastKey > -1 then
                begin
                  wdsReg.Locate('PriKey', iLastKey, []);
                  wdsReg.Insert;
                  wdsReg.FieldByName('Reg').asString       := wdsTempReg.FieldByName('Reg').asString;
                  wdsReg.FieldByName('FleetNo').asString   := wdsTempReg.FieldByName('FleetNo').asString;
                  wdsReg.FieldByName('FleetType').asString := wdsTempReg.FieldByName('FleetType').asString;
                  wdsReg.FieldByName('Selected').asBoolean := wdsTempReg.FieldByName('Selected').asBoolean;
                  wdsReg.FieldByName('PriKey').asInteger   := wdsTempReg.FieldByName('PriKey').asInteger;
                  wdsReg.Post;
                end
              else
                begin
                  wdsReg.First;
                  wdsReg.Insert;
                  wdsReg.FieldByName('Reg').asString       := wdsTempReg.FieldByName('Reg').asString;
                  wdsReg.FieldByName('FleetNo').asString   := wdsTempReg.FieldByName('FleetNo').asString;
                  wdsReg.FieldByName('FleetType').asString := wdsTempReg.FieldByName('FleetType').asString;
                  wdsReg.FieldByName('Selected').asBoolean := wdsTempReg.FieldByName('Selected').asBoolean;
                  wdsReg.FieldByName('PriKey').asInteger   := wdsTempReg.FieldByName('PriKey').asInteger;
                  wdsReg.Post;
                end;
            end;
          iLastKey := wdsTempReg.FieldByName('PriKey').asInteger;
          wdsTempReg.Next;
        Until wdsTempReg.Eof;
        wdsReg.Locate('PriKey', iCurrentKey, []);
        wdsTempReg.Close;
        wdsReg.EnableControls;
      end;
  end;
begin
  wcReg.RawInvoke('IdashboardService.GetReg', [4,GetJsonArrayFromDataSet(wdsYears,true,'Selected'),GetJsonArrayFromDataSet(wdsMonths,true,'Selected')], @OnResult);
end;

procedure TfrmDashBoardMaintenance.gCostGroupsCellClick(Sender: TObject; ACol,
  ARow: Integer);
var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= gCostGroups.FixedRows - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(gdaCostGroups);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[2];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsCostGroups.Edit;
                        d.FieldAtColumn[2].asBoolean := False;
                        wdsCostGroups.Post;
                      end
                    else
                      begin
                        wdsCostGroups.Edit;
                        d.FieldAtColumn[2].asBoolean := True;
                        wdsCostGroups.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.gCostGroupsGetCellLayout(Sender: TObject;
  ACol, ARow: Integer; ALayout: TTMSFNCGridCellLayout;
  ACellState: TTMSFNCGridCellState);
var
    Bitmap : TTMSFNCBitmap;
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= gCostGroups.FixedRows - 1 then
    Exit;

  Try
    If ACol = 3 then
      begin
        d := TTMSFNCGridDataBaseAdapterOpen(gdaCostGroups);
        if d.CheckDataSet then
          begin
            ar := d.DataLink.ActiveRecord;
            try
              d.SetActiveRecord(ARow);
              fName := d.FieldAtColumn[0];
              if Assigned(fName) then
                begin
                  If Trim(fName.AsString) <> '' then
                    begin
                      fSuspended := d.FieldAtColumn[2];
                      if Assigned(fSuspended) then
                        begin
                          Bitmap := TTMSFNCBitmap.Create;
                          If fSuspended.AsBoolean then
                            Bitmap.LoadFromURL('images/status/green-switch.svg')
                          else
                            Bitmap.LoadFromURL('images/status/red-switch.svg');
                          gCostGroups.AddBitmap(ACol,ARow,Bitmap);
                          Bitmap.Free;
                        end;
                    end;
                end;
            finally
              d.DataLink.ActiveRecord := ar;
            end;
          end;
      end;
  except

  End;
end;


procedure TfrmDashBoardMaintenance.gDashDataSortFormat(Sender: TObject;
  Col: Integer; var SortFormat: TTMSFNCGridSortFormat; var APrefix,
  ASuffix: string);
begin
 case Col of

    3 : SortFormat := ssNumeric;
    4 : SortFormat := ssNumeric;
    10 : SortFormat := ssNumeric;


  end;
end;

procedure TfrmDashBoardMaintenance.gMonthsCellClick(Sender: TObject; ACol,
  ARow: Integer);
  var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= gMonths.FixedRows - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(gdaMonths);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[2];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsMonths.Edit;
                        d.FieldAtColumn[2].asBoolean := False;
                        wdsMonths.Post;
                      end
                    else
                      begin
                        wdsMonths.Edit;
                        d.FieldAtColumn[2].asBoolean := True;
                        wdsMonths.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.gMonthsGetCellLayout(Sender: TObject; ACol,
  ARow: Integer; ALayout: TTMSFNCGridCellLayout;
  ACellState: TTMSFNCGridCellState);
  var
    Bitmap : TTMSFNCBitmap;
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= gMonths.FixedRows - 1 then
    Exit;

  Try
    If ACol = 3 then
      begin
        d := TTMSFNCGridDataBaseAdapterOpen(gdaMonths);
        if d.CheckDataSet then
          begin
            ar := d.DataLink.ActiveRecord;
            try
              d.SetActiveRecord(ARow);
              fName := d.FieldAtColumn[0];
              if Assigned(fName) then
                begin
                  If Trim(fName.AsString) <> '' then
                    begin
                      fSuspended := d.FieldAtColumn[2];
                      if Assigned(fSuspended) then
                        begin
                          Bitmap := TTMSFNCBitmap.Create;
                          If fSuspended.AsBoolean then
                            Bitmap.LoadFromURL('images/status/green-switch.svg')
                          else
                            Bitmap.LoadFromURL('images/status/red-switch.svg');
                          gMonths.AddBitmap(ACol,ARow,Bitmap);
                          Bitmap.Free;
                        end;
                    end;
                end;
            finally
              d.DataLink.ActiveRecord := ar;
            end;
          end;
      end;
  except

  End;
end;

procedure TfrmDashBoardMaintenance.gRegCellClick(Sender: TObject; ACol,
  ARow: Integer);
var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= gReg.FixedRows - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(gdaReg);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[2];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsReg.Edit;
                        d.FieldAtColumn[2].asBoolean := False;
                        wdsReg.Post;
                      end
                    else
                      begin
                        wdsReg.Edit;
                        d.FieldAtColumn[2].asBoolean := True;
                        wdsReg.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.gRegGetCellLayout(Sender: TObject; ACol,
  ARow: Integer; ALayout: TTMSFNCGridCellLayout;
  ACellState: TTMSFNCGridCellState);
  var
    Bitmap : TTMSFNCBitmap;
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= gYears.FixedRows - 1 then
    Exit;
  Try
    If ACol = 3 then
      begin
        d := TTMSFNCGridDataBaseAdapterOpen(gdaReg);
        if d.CheckDataSet then
          begin
            ar := d.DataLink.ActiveRecord;
            try
              d.SetActiveRecord(ARow);
              fName := d.FieldAtColumn[0];
              if Assigned(fName) then
                begin
                  If Trim(fName.AsString) <> '' then
                    begin
                      fSuspended := d.FieldAtColumn[2];
                      if Assigned(fSuspended) then
                        begin
                          Bitmap := TTMSFNCBitmap.Create;
                          If fSuspended.AsBoolean then
                            Bitmap.LoadFromURL('images/status/green-switch.svg')
                          else
                            Bitmap.LoadFromURL('images/status/red-switch.svg');
                          gReg.AddBitmap(ACol,ARow,Bitmap);
                          Bitmap.Free;
                        end;
                    end;
                end;
            finally
              d.DataLink.ActiveRecord := ar;
            end;
          end;
      end;
  except

  End;
end;

procedure TfrmDashBoardMaintenance.gSysTypesCellClick(Sender: TObject; ACol,
  ARow: Integer);
var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= gSysTypes.FixedRows - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(gdaSysTypes);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[2];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsSysTypes.Edit;
                        d.FieldAtColumn[2].asBoolean := False;
                        wdsSysTypes.Post;
                      end
                    else
                      begin
                        wdsSysTypes.Edit;
                        d.FieldAtColumn[2].asBoolean := True;
                        wdsSysTypes.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.gSysTypesGetCellLayout(Sender: TObject; ACol,
  ARow: Integer; ALayout: TTMSFNCGridCellLayout;
  ACellState: TTMSFNCGridCellState);
  var
    Bitmap : TTMSFNCBitmap;
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= gSysTypes.FixedRows - 1 then
    Exit;

  Try
    If ACol = 3 then
      begin
        d := TTMSFNCGridDataBaseAdapterOpen(gdaSysTypes);
        if d.CheckDataSet then
          begin
            ar := d.DataLink.ActiveRecord;
            try
              d.SetActiveRecord(ARow);
              fName := d.FieldAtColumn[0];
              if Assigned(fName) then
                begin
                  If Trim(fName.AsString) <> '' then
                    begin
                      fSuspended := d.FieldAtColumn[2];
                      if Assigned(fSuspended) then
                        begin
                          Bitmap := TTMSFNCBitmap.Create;
                          If fSuspended.AsBoolean then
                            Bitmap.LoadFromURL('images/status/green-switch.svg')
                          else
                            Bitmap.LoadFromURL('images/status/red-switch.svg');
                          gSysTypes.AddBitmap(ACol,ARow,Bitmap);
                          Bitmap.Free;
                        end;
                    end;
                end;
            finally
              d.DataLink.ActiveRecord := ar;
            end;
          end;
      end;
  except

  End;
end;


procedure TfrmDashBoardMaintenance.gYearsCellClick(Sender: TObject; ACol,
  ARow: Integer);
var
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= gYears.FixedRows - 1 then
    Exit;

  d := TTMSFNCGridDataBaseAdapterOpen(gdaYears);
  if d.CheckDataSet then
    begin
      ar := d.DataLink.ActiveRecord;
      try
        d.SetActiveRecord(ARow);
        fName := d.FieldAtColumn[0];
        if Assigned(fName) then
          begin
            If Trim(fName.AsString) <> '' then
              begin
                fSuspended := d.FieldAtColumn[1];
                if Assigned(fSuspended) then
                  begin
                    If fSuspended.AsBoolean then
                      begin
                        wdsYears.Edit;
                        d.FieldAtColumn[1].asBoolean := False;
                        wdsYears.Post;
                      end
                    else
                      begin
                        wdsYears.Edit;
                        d.FieldAtColumn[1].asBoolean := True;
                        wdsYears.Post;
                      end;
                  end;
              end;
          end;
      finally
        d.DataLink.ActiveRecord := ar;
      end;
    end;
end;

procedure TfrmDashBoardMaintenance.gYearsGetCellLayout(Sender: TObject; ACol,
  ARow: Integer; ALayout: TTMSFNCGridCellLayout;
  ACellState: TTMSFNCGridCellState);
  var
    Bitmap : TTMSFNCBitmap;
    d: TTMSFNCGridDataBaseAdapterOpen;
    ar : Integer;
    fName, fSuspended: TField;
    bSyspended : Boolean;
begin
  If ARow <= gYears.FixedRows - 1 then
    Exit;
  Try
    If ACol = 2 then
      begin
        d := TTMSFNCGridDataBaseAdapterOpen(gdaYears);
        if d.CheckDataSet then
          begin
            ar := d.DataLink.ActiveRecord;
            try
              d.SetActiveRecord(ARow);
              fName := d.FieldAtColumn[0];
              if Assigned(fName) then
                begin
                  If Trim(fName.AsString) <> '' then
                    begin
                      fSuspended := d.FieldAtColumn[1];
                      if Assigned(fSuspended) then
                        begin
                          Bitmap := TTMSFNCBitmap.Create;
                          If fSuspended.AsBoolean then
                            Bitmap.LoadFromURL('images/status/green-switch.svg')
                          else
                            Bitmap.LoadFromURL('images/status/red-switch.svg');
                          gYears.AddBitmap(ACol,ARow,Bitmap);
                          Bitmap.Free;
                        end;
                    end;
                end;
            finally
              d.DataLink.ActiveRecord := ar;
            end;
          end;
      end;
  except

  End;
end;

procedure TfrmDashBoardMaintenance.TriggerTimer;
begin
  WebTimer1.Enabled := False;
  WebTimer1.Enabled := True;
end;

procedure TfrmDashBoardMaintenance.wdsCostGroupsAfterPost(DataSet: TDataSet);
begin
  TriggerTimer;
end;

procedure TfrmDashBoardMaintenance.wdsDashboardSumsAfterOpen(DataSet: TDataSet);
begin
  DoLoadMainDataDetails;
end;

procedure TfrmDashBoardMaintenance.wdsDashDataAfterOpen(DataSet: TDataSet);
begin

  gdaDashData.LoadAllDataAndDisconnect;
  WebWaitMessage1.Hide;
end;

procedure TfrmDashBoardMaintenance.wdsMonthsAfterPost(DataSet: TDataSet);
begin
  TriggerTimer;
end;

procedure TfrmDashBoardMaintenance.wdsSysTypesAfterPost(DataSet: TDataSet);
begin
  TriggerTimer;
end;

procedure TfrmDashBoardMaintenance.wdsYearsAfterPost(DataSet: TDataSet);
begin
  TriggerTimer;
end;

procedure TfrmDashBoardMaintenance.wbExcelClick(Sender: TObject);
begin

  WebWaitMessage1.Show;
  CallMaintReport('Maintdetail.xlsx', 'XLSX');

end;

procedure TfrmDashBoardMaintenance.wbSearchClick(Sender: TObject);
begin
  WebWaitMessage1.Show;
  gdaDashData.Active := True;
  DoLoadMainData;
    //DoLoadMainDataDetails;

end;

procedure TfrmDashBoardMaintenance.WebButton2Click(Sender: TObject);
begin

  CallMaintReport('Maintdetail.xlsx', 'XLSX');

end;

procedure TfrmDashBoardMaintenance.WebFormResize(Sender: TObject);
begin
  pMainTop.Height := pMain.Height div 3;
end;

procedure TfrmDashBoardMaintenance.WebFormShow(Sender: TObject);
begin
  DoLoadYears;


end;

procedure TfrmDashBoardMaintenance.WebSpeedButton1Click(Sender: TObject);
begin
  wdssysTypes.DisableControls;
  wdssysTypes.First;
  Repeat
    If wdssysTypes.FieldByName('Selected').asBoolean then
      begin
        wdssysTypes.Edit;
        wdssysTypes.FieldByName('Selected').asBoolean := False;
        wdssysTypes.Post;
      end;
    wdssysTypes.Next;
  Until wdssysTypes.Eof;
  wdssysTypes.First;
  wdssysTypes.EnableControls;
end;

procedure TfrmDashBoardMaintenance.WebSpeedButton2Click(Sender: TObject);
begin
  wdsCostGroups.DisableControls;
  wdsCostGroups.First;
  Repeat
    If wdsCostGroups.FieldByName('Selected').asBoolean then
      begin
        wdsCostGroups.Edit;
        wdsCostGroups.FieldByName('Selected').asBoolean := False;
        wdsCostGroups.Post;
      end;
    wdsCostGroups.Next;
  Until wdsCostGroups.Eof;
  wdsCostGroups.First;
  wdsCostGroups.EnableControls;
end;

procedure TfrmDashBoardMaintenance.btnMonthsClearClick(Sender: TObject);
begin
  wdsMonths.DisableControls;
  wdsMonths.First;
  Repeat
    If wdsMonths.FieldByName('Selected').asBoolean then
      begin
        wdsMonths.Edit;
        wdsMonths.FieldByName('Selected').asBoolean := False;
        wdsMonths.Post;
      end;
    wdsMonths.Next;
  Until wdsMonths.Eof;
  wdsMonths.First;
  wdsMonths.EnableControls;
end;

procedure TfrmDashBoardMaintenance.WebTimer1Timer(Sender: TObject);
begin
  WebTimer1.Enabled := False;
  DoRegInfo;
end;

procedure TfrmDashBoardMaintenance.CallMaintReport( sFilename, sReport : string);
begin


    downloadfile('IdashboardService.GetRepMainDetails',
                 sFileName,
                 [GetJsonArrayFromDataSet(wdsYears,true,'Selected'),
                  GetJsonArrayFromDataSet(wdsMonths,true,'Selected'),
                  GetJsonArrayFromDataSet(wdsReg,true,'Selected'),
                  GetJsonArrayFromDataSet(wdsSysTypes,true,'Selected'),
                  GetJsonArrayFromDataSet(wdsCostGroups,true,'Selected'),
                  sReport]);

    WebWaitMessage1.Hide;



end;

procedure TfrmDashBoardMaintenance.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pTop := TPanel.Create(Self);
  pBottom := TPanel.Create(Self);
  pMain := TPanel.Create(Self);
  pMainTop := TPanel.Create(Self);
  pMainMonths := TPanel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  gMonths := TTMSFNCGrid.Create(Self);
  gdaMonths := TTMSFNCGridDatabaseAdapter.Create(Self);
  btnMonthsClear := TSpeedButton.Create(Self);
  pMainYears := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  gYears := TTMSFNCGrid.Create(Self);
  gdaYears := TTMSFNCGridDatabaseAdapter.Create(Self);
  btnYearsClear := TSpeedButton.Create(Self);
  pRegNo := TPanel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  btnRegClear := TSpeedButton.Create(Self);
  gReg := TTMSFNCGrid.Create(Self);
  gdaReg := TTMSFNCGridDatabaseAdapter.Create(Self);
  pMaintTypes := TPanel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  gSysTypes := TTMSFNCGrid.Create(Self);
  gdaSysTypes := TTMSFNCGridDatabaseAdapter.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  pCostGroups := TPanel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  gCostGroups := TTMSFNCGrid.Create(Self);
  gdaCostGroups := TTMSFNCGridDatabaseAdapter.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebButton1 := TButton.Create(Self);
  wpDashSums := TPanel.Create(Self);
  wpTotalCost := TPanel.Create(Self);
  WebDBLabel1 := TDBLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebDBLabel10 := TDBLabel.Create(Self);
  wpMaintenance := TPanel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebDBLabel2 := TDBLabel.Create(Self);
  WebDBLabel11 := TDBLabel.Create(Self);
  wpTyres := TPanel.Create(Self);
  WebDBLabel5 := TDBLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebDBLabel12 := TDBLabel.Create(Self);
  wpCost := TPanel.Create(Self);
  WebDBLabel3 := TDBLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebDBLabel9 := TDBLabel.Create(Self);
  wpInsurance := TPanel.Create(Self);
  WebDBLabel4 := TDBLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebDBLabel13 := TDBLabel.Create(Self);
  wpOperational := TPanel.Create(Self);
  WebDBLabel6 := TDBLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebDBLabel14 := TDBLabel.Create(Self);
  wbSearch := TButton.Create(Self);
  wpCapex := TPanel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebDBLabel7 := TDBLabel.Create(Self);
  WebDBLabel15 := TDBLabel.Create(Self);
  wpUnAll := TPanel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebDBLabel8 := TDBLabel.Create(Self);
  WebDBLabel16 := TDBLabel.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  wbExcel := TButton.Create(Self);
  wpNoLink := TPanel.Create(Self);
  WebLabel17 := TLabel.Create(Self);
  WebDBLabel17 := TDBLabel.Create(Self);
  WebDBLabel18 := TDBLabel.Create(Self);
  pDashData := TPanel.Create(Self);
  gDashData := TTMSFNCGrid.Create(Self);
  gdaDashData := TTMSFNCGridDatabaseAdapter.Create(Self);
  WebWaitMessage1 := TWaitMessage.Create(Self);
  wcYears := TXDataWebClient.Create(Self);
  wdsYears := TXDataWebDataSet.Create(Self);
  wdsYearsSelected := TBooleanField.Create(Self);
  wdsYearsYear := TIntegerField.Create(Self);
  dsYears := TDataSource.Create(Self);
  wcMonths := TXDataWebClient.Create(Self);
  wdsMonths := TXDataWebDataSet.Create(Self);
  wdsMonthsMonth := TIntegerField.Create(Self);
  wdsMonthsMonthName := TStringField.Create(Self);
  wdsMonthsSelected := TBooleanField.Create(Self);
  dsMonths := TDataSource.Create(Self);
  wcReg := TXDataWebClient.Create(Self);
  wdsReg := TXDataWebDataSet.Create(Self);
  wdsRegReg := TStringField.Create(Self);
  wdsRegFleetNo := TStringField.Create(Self);
  wdsRegFleetType := TStringField.Create(Self);
  wdsRegSelected := TBooleanField.Create(Self);
  wdsRegPriKey := TIntegerField.Create(Self);
  dsReg := TDataSource.Create(Self);
  WebTimer1 := TTimer.Create(Self);
  wdsTempReg := TXDataWebDataSet.Create(Self);
  StringField1 := TStringField.Create(Self);
  StringField2 := TStringField.Create(Self);
  StringField3 := TStringField.Create(Self);
  BooleanField1 := TBooleanField.Create(Self);
  IntegerField1 := TIntegerField.Create(Self);
  dsSysTypes := TDataSource.Create(Self);
  wcSysTypes := TXDataWebClient.Create(Self);
  wdsSysTypes := TXDataWebDataSet.Create(Self);
  wdsSysTypesSelected := TBooleanField.Create(Self);
  wdsSysTypesSysType := TIntegerField.Create(Self);
  wdsSysTypesDescription := TStringField.Create(Self);
  wdsCostGroups := TXDataWebDataSet.Create(Self);
  wdsCostGroupsselected := TBooleanField.Create(Self);
  wdsCostGroupsCost := TIntegerField.Create(Self);
  wdsCostGroupsDescription := TStringField.Create(Self);
  dsCostGroups := TDataSource.Create(Self);
  wcCostGroups := TXDataWebClient.Create(Self);
  wdsDashboardSums := TXDataWebDataSet.Create(Self);
  wdsDashboardSumsMaintenanceCost := TStringField.Create(Self);
  wdsDashboardSumsTyreCost := TStringField.Create(Self);
  wdsDashboardSumsWashCost := TStringField.Create(Self);
  wdsDashboardSumsInsuranceCost := TStringField.Create(Self);
  wdsDashboardSumsOtherCost := TStringField.Create(Self);
  wdsDashboardSumsTotalCost := TStringField.Create(Self);
  wdsDashboardSumsCapexCost := TStringField.Create(Self);
  wdsDashboardSumsUnallCost := TStringField.Create(Self);
  wdsDashboardSumsTotalCPK := TStringField.Create(Self);
  wdsDashboardSumsMaintenanceCPK := TStringField.Create(Self);
  wdsDashboardSumsTyreCPK := TStringField.Create(Self);
  wdsDashboardSumsWashCPK := TStringField.Create(Self);
  wdsDashboardSumsInsuranceCPK := TStringField.Create(Self);
  wdsDashboardSumsOtherCPK := TStringField.Create(Self);
  wdsDashboardSumsCapexCPK := TStringField.Create(Self);
  wdsDashboardSumsUnallCPK := TStringField.Create(Self);
  wdsDashboardSumsNotLinkedCost := TStringField.Create(Self);
  wdsDashboardSumsNotLinkedCPK := TStringField.Create(Self);
  wdsDashData := TXDataWebDataSet.Create(Self);
  wdsDashDataJobcardNo := TIntegerField.Create(Self);
  wdsDashDataStockDescription := TStringField.Create(Self);
  wdsDashDataTotalExcl := TStringField.Create(Self);
  wdsDashDataGlCode := TStringField.Create(Self);
  wdsDashDataReason := TStringField.Create(Self);
  wdsDashDataCategory := TStringField.Create(Self);
  wdsDashDataRepMain := TStringField.Create(Self);
  wdsDashDataCostDescription := TStringField.Create(Self);
  wdsDashDataTRegNo := TStringField.Create(Self);
  wdsDashDataTFleetNo := TStringField.Create(Self);
  wdsDashDataOrderNo := TStringField.Create(Self);
  wdsDashDataJobDate := TStringField.Create(Self);
  wdsDashDataReferenceNo := TStringField.Create(Self);
  wdsDashDataVehType := TStringField.Create(Self);
  wdsDashDataJobType := TStringField.Create(Self);
  wdsDashDataSupplier := TStringField.Create(Self);
  wcDashboardSums := TXDataWebClient.Create(Self);
  dsDashBoardSums := TDataSource.Create(Self);
  wcDashData := TXDataWebClient.Create(Self);
  dsDashData := TDataSource.Create(Self);

  pTop.BeforeLoadDFMValues;
  pBottom.BeforeLoadDFMValues;
  pMain.BeforeLoadDFMValues;
  pMainTop.BeforeLoadDFMValues;
  pMainMonths.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  gMonths.BeforeLoadDFMValues;
  gdaMonths.BeforeLoadDFMValues;
  btnMonthsClear.BeforeLoadDFMValues;
  pMainYears.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  gYears.BeforeLoadDFMValues;
  gdaYears.BeforeLoadDFMValues;
  btnYearsClear.BeforeLoadDFMValues;
  pRegNo.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  btnRegClear.BeforeLoadDFMValues;
  gReg.BeforeLoadDFMValues;
  gdaReg.BeforeLoadDFMValues;
  pMaintTypes.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  gSysTypes.BeforeLoadDFMValues;
  gdaSysTypes.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  pCostGroups.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  gCostGroups.BeforeLoadDFMValues;
  gdaCostGroups.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  wpDashSums.BeforeLoadDFMValues;
  wpTotalCost.BeforeLoadDFMValues;
  WebDBLabel1.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebDBLabel10.BeforeLoadDFMValues;
  wpMaintenance.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebDBLabel2.BeforeLoadDFMValues;
  WebDBLabel11.BeforeLoadDFMValues;
  wpTyres.BeforeLoadDFMValues;
  WebDBLabel5.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebDBLabel12.BeforeLoadDFMValues;
  wpCost.BeforeLoadDFMValues;
  WebDBLabel3.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebDBLabel9.BeforeLoadDFMValues;
  wpInsurance.BeforeLoadDFMValues;
  WebDBLabel4.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebDBLabel13.BeforeLoadDFMValues;
  wpOperational.BeforeLoadDFMValues;
  WebDBLabel6.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebDBLabel14.BeforeLoadDFMValues;
  wbSearch.BeforeLoadDFMValues;
  wpCapex.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebDBLabel7.BeforeLoadDFMValues;
  WebDBLabel15.BeforeLoadDFMValues;
  wpUnAll.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebDBLabel8.BeforeLoadDFMValues;
  WebDBLabel16.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  wbExcel.BeforeLoadDFMValues;
  wpNoLink.BeforeLoadDFMValues;
  WebLabel17.BeforeLoadDFMValues;
  WebDBLabel17.BeforeLoadDFMValues;
  WebDBLabel18.BeforeLoadDFMValues;
  pDashData.BeforeLoadDFMValues;
  gDashData.BeforeLoadDFMValues;
  gdaDashData.BeforeLoadDFMValues;
  WebWaitMessage1.BeforeLoadDFMValues;
  wcYears.BeforeLoadDFMValues;
  wdsYears.BeforeLoadDFMValues;
  wdsYearsSelected.BeforeLoadDFMValues;
  wdsYearsYear.BeforeLoadDFMValues;
  dsYears.BeforeLoadDFMValues;
  wcMonths.BeforeLoadDFMValues;
  wdsMonths.BeforeLoadDFMValues;
  wdsMonthsMonth.BeforeLoadDFMValues;
  wdsMonthsMonthName.BeforeLoadDFMValues;
  wdsMonthsSelected.BeforeLoadDFMValues;
  dsMonths.BeforeLoadDFMValues;
  wcReg.BeforeLoadDFMValues;
  wdsReg.BeforeLoadDFMValues;
  wdsRegReg.BeforeLoadDFMValues;
  wdsRegFleetNo.BeforeLoadDFMValues;
  wdsRegFleetType.BeforeLoadDFMValues;
  wdsRegSelected.BeforeLoadDFMValues;
  wdsRegPriKey.BeforeLoadDFMValues;
  dsReg.BeforeLoadDFMValues;
  WebTimer1.BeforeLoadDFMValues;
  wdsTempReg.BeforeLoadDFMValues;
  StringField1.BeforeLoadDFMValues;
  StringField2.BeforeLoadDFMValues;
  StringField3.BeforeLoadDFMValues;
  BooleanField1.BeforeLoadDFMValues;
  IntegerField1.BeforeLoadDFMValues;
  dsSysTypes.BeforeLoadDFMValues;
  wcSysTypes.BeforeLoadDFMValues;
  wdsSysTypes.BeforeLoadDFMValues;
  wdsSysTypesSelected.BeforeLoadDFMValues;
  wdsSysTypesSysType.BeforeLoadDFMValues;
  wdsSysTypesDescription.BeforeLoadDFMValues;
  wdsCostGroups.BeforeLoadDFMValues;
  wdsCostGroupsselected.BeforeLoadDFMValues;
  wdsCostGroupsCost.BeforeLoadDFMValues;
  wdsCostGroupsDescription.BeforeLoadDFMValues;
  dsCostGroups.BeforeLoadDFMValues;
  wcCostGroups.BeforeLoadDFMValues;
  wdsDashboardSums.BeforeLoadDFMValues;
  wdsDashboardSumsMaintenanceCost.BeforeLoadDFMValues;
  wdsDashboardSumsTyreCost.BeforeLoadDFMValues;
  wdsDashboardSumsWashCost.BeforeLoadDFMValues;
  wdsDashboardSumsInsuranceCost.BeforeLoadDFMValues;
  wdsDashboardSumsOtherCost.BeforeLoadDFMValues;
  wdsDashboardSumsTotalCost.BeforeLoadDFMValues;
  wdsDashboardSumsCapexCost.BeforeLoadDFMValues;
  wdsDashboardSumsUnallCost.BeforeLoadDFMValues;
  wdsDashboardSumsTotalCPK.BeforeLoadDFMValues;
  wdsDashboardSumsMaintenanceCPK.BeforeLoadDFMValues;
  wdsDashboardSumsTyreCPK.BeforeLoadDFMValues;
  wdsDashboardSumsWashCPK.BeforeLoadDFMValues;
  wdsDashboardSumsInsuranceCPK.BeforeLoadDFMValues;
  wdsDashboardSumsOtherCPK.BeforeLoadDFMValues;
  wdsDashboardSumsCapexCPK.BeforeLoadDFMValues;
  wdsDashboardSumsUnallCPK.BeforeLoadDFMValues;
  wdsDashboardSumsNotLinkedCost.BeforeLoadDFMValues;
  wdsDashboardSumsNotLinkedCPK.BeforeLoadDFMValues;
  wdsDashData.BeforeLoadDFMValues;
  wdsDashDataJobcardNo.BeforeLoadDFMValues;
  wdsDashDataStockDescription.BeforeLoadDFMValues;
  wdsDashDataTotalExcl.BeforeLoadDFMValues;
  wdsDashDataGlCode.BeforeLoadDFMValues;
  wdsDashDataReason.BeforeLoadDFMValues;
  wdsDashDataCategory.BeforeLoadDFMValues;
  wdsDashDataRepMain.BeforeLoadDFMValues;
  wdsDashDataCostDescription.BeforeLoadDFMValues;
  wdsDashDataTRegNo.BeforeLoadDFMValues;
  wdsDashDataTFleetNo.BeforeLoadDFMValues;
  wdsDashDataOrderNo.BeforeLoadDFMValues;
  wdsDashDataJobDate.BeforeLoadDFMValues;
  wdsDashDataReferenceNo.BeforeLoadDFMValues;
  wdsDashDataVehType.BeforeLoadDFMValues;
  wdsDashDataJobType.BeforeLoadDFMValues;
  wdsDashDataSupplier.BeforeLoadDFMValues;
  wcDashboardSums.BeforeLoadDFMValues;
  dsDashBoardSums.BeforeLoadDFMValues;
  wcDashData.BeforeLoadDFMValues;
  dsDashData.BeforeLoadDFMValues;
  try
    Name := 'frmDashBoardMaintenance';
    Left := 776;
    Width := 2000;
    Height := 578;
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    pTop.SetParentComponent(Self);
    pTop.Name := 'pTop';
    pTop.Left := 0;
    pTop.Top := 0;
    pTop.Width := 2000;
    pTop.Height := 41;
    pTop.Align := alTop;
    pTop.Caption := 'Maintenance Dashboard';
    pTop.Color := clSkyBlue;
    pTop.Font.Charset := DEFAULT_CHARSET;
    pTop.Font.Color := clWindowText;
    pTop.Font.Height := -12;
    pTop.Font.Name := 'Segoe UI';
    pTop.Font.Style := [fsBold];
    pTop.ParentFont := False;
    pTop.TabOrder := 0;
    pBottom.SetParentComponent(Self);
    pBottom.Name := 'pBottom';
    pBottom.Left := 0;
    pBottom.Top := 538;
    pBottom.Width := 2000;
    pBottom.Height := 40;
    pBottom.Align := alBottom;
    pBottom.ChildOrder := 1;
    pBottom.TabOrder := 1;
    pMain.SetParentComponent(Self);
    pMain.Name := 'pMain';
    pMain.Left := 0;
    pMain.Top := 41;
    pMain.Width := 2000;
    pMain.Height := 497;
    pMain.Align := alClient;
    pMain.ChildOrder := 2;
    pMain.TabOrder := 2;
    pMainTop.SetParentComponent(pMain);
    pMainTop.Name := 'pMainTop';
    pMainTop.Left := 0;
    pMainTop.Top := 0;
    pMainTop.Width := 2000;
    pMainTop.Height := 193;
    pMainTop.Align := alTop;
    pMainTop.BorderStyle := bsNone;
    pMainTop.ChildOrder := 2;
    pMainTop.TabOrder := 0;
    pMainMonths.SetParentComponent(pMainTop);
    pMainMonths.Name := 'pMainMonths';
    pMainMonths.Left := 161;
    pMainMonths.Top := 0;
    pMainMonths.Width := 161;
    pMainMonths.Height := 193;
    pMainMonths.Align := alLeft;
    pMainMonths.ChildOrder := 2;
    pMainMonths.TabOrder := 0;
    WebLabel2.SetParentComponent(pMainMonths);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 0;
    WebLabel2.Top := 0;
    WebLabel2.Width := 161;
    WebLabel2.Height := 15;
    WebLabel2.Align := alTop;
    WebLabel2.Alignment := taCenter;
    WebLabel2.Caption := 'Select Months';
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clWindowText;
    WebLabel2.Font.Height := -12;
    WebLabel2.Font.Name := 'Segoe UI';
    WebLabel2.Font.Style := [fsBold];
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WidthPercent := 100.000000000000000000;
    gMonths.SetParentComponent(pMainMonths);
    gMonths.Name := 'gMonths';
    gMonths.Left := 0;
    gMonths.Top := 15;
    gMonths.Width := 161;
    gMonths.Height := 154;
    gMonths.Align := alClient;
    gMonths.ParentDoubleBuffered := False;
    gMonths.DoubleBuffered := True;
    gMonths.TabOrder := 0;
    gMonths.DefaultRowHeight := 30.000000000000000000;
    gMonths.FixedColumns := 0;
    gMonths.ColumnCount := 2;
    gMonths.RowCount := 1;
    gMonths.Options.Bands.Enabled := True;
    gMonths.Options.Editing.CalcFormat := '%g';
    gMonths.Options.Editing.Enabled := False;
    gMonths.Options.Grouping.CalcFormat := '%g';
    gMonths.Options.Grouping.GroupCountFormat := '(%d)';
    gMonths.Options.IO.XMLEncoding := 'ISO-8859-1';
    gMonths.Options.Mouse.ClickMargin := 0;
    gMonths.Options.Mouse.ColumnSizeMargin := 6;
    gMonths.Options.Mouse.RowSizeMargin := 6;
    gMonths.Options.Selection.Mode := smRowRange;
    gMonths.Adapter := gdaMonths;
    gMonths.Columns.Clear;
    with gMonths.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaCenter;
      ID := '';
      Width := 80.000000000000000000;
    end;
    with gMonths.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gMonths.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gMonths.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 50.000000000000000000;
    end;
    gMonths.DefaultFont.Charset := DEFAULT_CHARSET;
    gMonths.DefaultFont.Color := clWindowText;
    gMonths.DefaultFont.Height := -11;
    gMonths.DefaultFont.Name := 'Segoe UI';
    gMonths.DefaultFont.Style := [];
    gMonths.TopRow := 1;
    gMonths.Appearance.FixedLayout.Fill.Color := 16380654;
    gMonths.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gMonths.Appearance.FixedLayout.Font.Color := 4539717;
    gMonths.Appearance.FixedLayout.Font.Height := -13;
    gMonths.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    gMonths.Appearance.FixedLayout.Font.Style := [fsBold];
    gMonths.Appearance.NormalLayout.Fill.Color := 16578806;
    gMonths.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gMonths.Appearance.NormalLayout.Font.Color := 8026746;
    gMonths.Appearance.NormalLayout.Font.Height := -11;
    gMonths.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    gMonths.Appearance.NormalLayout.Font.Style := [];
    gMonths.Appearance.GroupLayout.Fill.Color := 12817262;
    gMonths.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gMonths.Appearance.GroupLayout.Font.Color := clBlack;
    gMonths.Appearance.GroupLayout.Font.Height := -11;
    gMonths.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    gMonths.Appearance.GroupLayout.Font.Style := [];
    gMonths.Appearance.SummaryLayout.Fill.Color := 14009785;
    gMonths.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gMonths.Appearance.SummaryLayout.Font.Color := clBlack;
    gMonths.Appearance.SummaryLayout.Font.Height := -11;
    gMonths.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    gMonths.Appearance.SummaryLayout.Font.Style := [];
    gMonths.Appearance.SelectedLayout.Fill.Color := 16441019;
    gMonths.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gMonths.Appearance.SelectedLayout.Font.Color := 4539717;
    gMonths.Appearance.SelectedLayout.Font.Height := -11;
    gMonths.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    gMonths.Appearance.SelectedLayout.Font.Style := [];
    gMonths.Appearance.FocusedLayout.Fill.Color := 16039284;
    gMonths.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gMonths.Appearance.FocusedLayout.Font.Color := 4539717;
    gMonths.Appearance.FocusedLayout.Font.Height := -11;
    gMonths.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    gMonths.Appearance.FocusedLayout.Font.Style := [];
    gMonths.Appearance.FixedSelectedLayout.Fill.Color := clLightsteelblue;
    gMonths.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gMonths.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    gMonths.Appearance.FixedSelectedLayout.Font.Height := -11;
    gMonths.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gMonths.Appearance.FixedSelectedLayout.Font.Style := [];
    gMonths.Appearance.BandLayout.Fill.Color := 16711679;
    gMonths.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gMonths.Appearance.BandLayout.Font.Color := 8026746;
    gMonths.Appearance.BandLayout.Font.Height := -11;
    gMonths.Appearance.BandLayout.Font.Name := 'Segoe UI';
    gMonths.Appearance.BandLayout.Font.Style := [];
    gMonths.Appearance.ProgressLayout.Format := '%.0f%%';
    gMonths.LeftCol := 0;
    gMonths.ScrollMode := scmItemScrolling;
    gMonths.DesignTimeSampleData := True;
    SetEvent(gMonths, Self, 'OnGetCellLayout', 'gMonthsGetCellLayout');
    SetEvent(gMonths, Self, 'OnCellClick', 'gMonthsCellClick');
    gdaMonths.SetParentComponent(gMonths);
    gdaMonths.Name := 'gdaMonths';
    gdaMonths.Left := 88;
    gdaMonths.Top := 6;
    gdaMonths.Width := 26;
    gdaMonths.Height := 26;
    gdaMonths.Visible := True;
    gdaMonths.Active := True;
    gdaMonths.Grid := gMonths;
    gdaMonths.DataSource := dsMonths;
    gdaMonths.Columns.Clear;
    with gdaMonths.Columns.Add do
    begin
      FieldName := 'MonthName';
      Header := 'Month';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaMonths.Columns.Add do
    begin
      FieldName := 'Month';
      Header := 'MonthNo';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaMonths.Columns.Add do
    begin
      FieldName := 'Selected';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaMonths.Columns.Add do
    begin
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    btnMonthsClear.SetParentComponent(pMainMonths);
    btnMonthsClear.Name := 'btnMonthsClear';
    btnMonthsClear.Left := 0;
    btnMonthsClear.Top := 169;
    btnMonthsClear.Width := 161;
    btnMonthsClear.Height := 24;
    btnMonthsClear.Align := alBottom;
    btnMonthsClear.Caption := 'Clear';
    btnMonthsClear.Color := clNone;
    btnMonthsClear.HeightPercent := 100.000000000000000000;
    btnMonthsClear.TabOrder := 1;
    btnMonthsClear.WidthPercent := 100.000000000000000000;
    SetEvent(btnMonthsClear, Self, 'OnClick', 'btnMonthsClearClick');
    pMainYears.SetParentComponent(pMainTop);
    pMainYears.Name := 'pMainYears';
    pMainYears.Left := 0;
    pMainYears.Top := 0;
    pMainYears.Width := 161;
    pMainYears.Height := 193;
    pMainYears.Align := alLeft;
    pMainYears.BorderStyle := bsNone;
    pMainYears.ChildOrder := 1;
    pMainYears.TabOrder := 1;
    WebLabel1.SetParentComponent(pMainYears);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 0;
    WebLabel1.Width := 161;
    WebLabel1.Height := 15;
    WebLabel1.Align := alTop;
    WebLabel1.Alignment := taCenter;
    WebLabel1.Caption := 'Select Years';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -12;
    WebLabel1.Font.Name := 'Segoe UI';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    gYears.SetParentComponent(pMainYears);
    gYears.Name := 'gYears';
    gYears.Left := 0;
    gYears.Top := 15;
    gYears.Width := 161;
    gYears.Height := 154;
    gYears.Align := alClient;
    gYears.ParentDoubleBuffered := False;
    gYears.DoubleBuffered := True;
    gYears.TabOrder := 0;
    gYears.DefaultRowHeight := 30.000000000000000000;
    gYears.FixedColumns := 0;
    gYears.ColumnCount := 2;
    gYears.RowCount := 1;
    gYears.Options.Bands.Enabled := True;
    gYears.Options.Editing.CalcFormat := '%g';
    gYears.Options.Editing.Enabled := False;
    gYears.Options.Grouping.CalcFormat := '%g';
    gYears.Options.Grouping.GroupCountFormat := '(%d)';
    gYears.Options.IO.XMLEncoding := 'ISO-8859-1';
    gYears.Options.Mouse.ClickMargin := 0;
    gYears.Options.Mouse.ColumnSizeMargin := 6;
    gYears.Options.Mouse.RowSizeMargin := 6;
    gYears.Options.Selection.Mode := smRowRange;
    gYears.Adapter := gdaYears;
    gYears.Columns.Clear;
    with gYears.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaCenter;
      ID := '';
      Width := 80.000000000000000000;
    end;
    with gYears.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gYears.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 50.000000000000000000;
    end;
    gYears.DefaultFont.Charset := DEFAULT_CHARSET;
    gYears.DefaultFont.Color := clWindowText;
    gYears.DefaultFont.Height := -11;
    gYears.DefaultFont.Name := 'Segoe UI';
    gYears.DefaultFont.Style := [];
    gYears.TopRow := 1;
    gYears.Appearance.FixedLayout.Fill.Color := 16380654;
    gYears.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gYears.Appearance.FixedLayout.Font.Color := 4539717;
    gYears.Appearance.FixedLayout.Font.Height := -13;
    gYears.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    gYears.Appearance.FixedLayout.Font.Style := [fsBold];
    gYears.Appearance.NormalLayout.Fill.Color := 16578806;
    gYears.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gYears.Appearance.NormalLayout.Font.Color := 8026746;
    gYears.Appearance.NormalLayout.Font.Height := -11;
    gYears.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    gYears.Appearance.NormalLayout.Font.Style := [];
    gYears.Appearance.GroupLayout.Fill.Color := 12817262;
    gYears.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gYears.Appearance.GroupLayout.Font.Color := clBlack;
    gYears.Appearance.GroupLayout.Font.Height := -11;
    gYears.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    gYears.Appearance.GroupLayout.Font.Style := [];
    gYears.Appearance.SummaryLayout.Fill.Color := 14009785;
    gYears.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gYears.Appearance.SummaryLayout.Font.Color := clBlack;
    gYears.Appearance.SummaryLayout.Font.Height := -11;
    gYears.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    gYears.Appearance.SummaryLayout.Font.Style := [];
    gYears.Appearance.SelectedLayout.Fill.Color := 16441019;
    gYears.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gYears.Appearance.SelectedLayout.Font.Color := 4539717;
    gYears.Appearance.SelectedLayout.Font.Height := -11;
    gYears.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    gYears.Appearance.SelectedLayout.Font.Style := [];
    gYears.Appearance.FocusedLayout.Fill.Color := 16039284;
    gYears.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gYears.Appearance.FocusedLayout.Font.Color := 4539717;
    gYears.Appearance.FocusedLayout.Font.Height := -11;
    gYears.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    gYears.Appearance.FocusedLayout.Font.Style := [];
    gYears.Appearance.FixedSelectedLayout.Fill.Color := clLightsteelblue;
    gYears.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gYears.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    gYears.Appearance.FixedSelectedLayout.Font.Height := -11;
    gYears.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gYears.Appearance.FixedSelectedLayout.Font.Style := [];
    gYears.Appearance.BandLayout.Fill.Color := 16711679;
    gYears.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gYears.Appearance.BandLayout.Font.Color := 8026746;
    gYears.Appearance.BandLayout.Font.Height := -11;
    gYears.Appearance.BandLayout.Font.Name := 'Segoe UI';
    gYears.Appearance.BandLayout.Font.Style := [];
    gYears.Appearance.ProgressLayout.Format := '%.0f%%';
    gYears.LeftCol := 0;
    gYears.ScrollMode := scmItemScrolling;
    gYears.DesignTimeSampleData := True;
    SetEvent(gYears, Self, 'OnGetCellLayout', 'gYearsGetCellLayout');
    SetEvent(gYears, Self, 'OnCellClick', 'gYearsCellClick');
    gdaYears.SetParentComponent(gYears);
    gdaYears.Name := 'gdaYears';
    gdaYears.Left := 40;
    gdaYears.Top := 40;
    gdaYears.Width := 26;
    gdaYears.Height := 26;
    gdaYears.Visible := True;
    gdaYears.Active := True;
    gdaYears.Grid := gYears;
    gdaYears.DataSource := dsYears;
    gdaYears.Columns.Clear;
    with gdaYears.Columns.Add do
    begin
      FieldName := 'Year';
      Header := 'Years';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaYears.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Selected';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaYears.Columns.Add do
    begin
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    btnYearsClear.SetParentComponent(pMainYears);
    btnYearsClear.Name := 'btnYearsClear';
    btnYearsClear.Left := 0;
    btnYearsClear.Top := 169;
    btnYearsClear.Width := 161;
    btnYearsClear.Height := 24;
    btnYearsClear.Align := alBottom;
    btnYearsClear.Caption := 'Clear';
    btnYearsClear.Color := clNone;
    btnYearsClear.HeightPercent := 100.000000000000000000;
    btnYearsClear.TabOrder := 1;
    btnYearsClear.WidthPercent := 100.000000000000000000;
    SetEvent(btnYearsClear, Self, 'OnClick', 'btnYearsClearClick');
    pRegNo.SetParentComponent(pMainTop);
    pRegNo.Name := 'pRegNo';
    pRegNo.Left := 322;
    pRegNo.Top := 0;
    pRegNo.Width := 287;
    pRegNo.Height := 193;
    pRegNo.Align := alLeft;
    pRegNo.BorderStyle := bsNone;
    pRegNo.ChildOrder := 2;
    pRegNo.TabOrder := 2;
    WebLabel3.SetParentComponent(pRegNo);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 0;
    WebLabel3.Top := 0;
    WebLabel3.Width := 287;
    WebLabel3.Height := 15;
    WebLabel3.Align := alTop;
    WebLabel3.Alignment := taCenter;
    WebLabel3.Caption := 'Select Registration';
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -12;
    WebLabel3.Font.Name := 'Segoe UI';
    WebLabel3.Font.Style := [fsBold];
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    btnRegClear.SetParentComponent(pRegNo);
    btnRegClear.Name := 'btnRegClear';
    btnRegClear.Left := 0;
    btnRegClear.Top := 169;
    btnRegClear.Width := 287;
    btnRegClear.Height := 24;
    btnRegClear.Align := alBottom;
    btnRegClear.Caption := 'Clear';
    btnRegClear.Color := clNone;
    btnRegClear.HeightPercent := 100.000000000000000000;
    btnRegClear.TabOrder := 0;
    btnRegClear.WidthPercent := 100.000000000000000000;
    SetEvent(btnRegClear, Self, 'OnClick', 'btnRegClearClick');
    gReg.SetParentComponent(pRegNo);
    gReg.Name := 'gReg';
    gReg.Left := 0;
    gReg.Top := 15;
    gReg.Width := 287;
    gReg.Height := 154;
    gReg.Align := alClient;
    gReg.ParentDoubleBuffered := False;
    gReg.DoubleBuffered := True;
    gReg.TabOrder := 1;
    gReg.DefaultRowHeight := 30.000000000000000000;
    gReg.FixedColumns := 0;
    gReg.ColumnCount := 4;
    gReg.RowCount := 1;
    gReg.Options.Bands.Enabled := True;
    gReg.Options.Editing.CalcFormat := '%g';
    gReg.Options.Editing.Enabled := False;
    gReg.Options.Grouping.CalcFormat := '%g';
    gReg.Options.Grouping.GroupCountFormat := '(%d)';
    gReg.Options.IO.XMLEncoding := 'ISO-8859-1';
    gReg.Options.Mouse.ClickMargin := 0;
    gReg.Options.Mouse.ColumnSizeMargin := 6;
    gReg.Options.Mouse.RowSizeMargin := 6;
    gReg.Adapter := gdaReg;
    gReg.Columns.Clear;
    with gReg.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 70.000000000000000000;
    end;
    with gReg.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 100.000000000000000000;
    end;
    with gReg.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gReg.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 50.000000000000000000;
    end;
    gReg.DefaultFont.Charset := DEFAULT_CHARSET;
    gReg.DefaultFont.Color := clWindowText;
    gReg.DefaultFont.Height := -11;
    gReg.DefaultFont.Name := 'Segoe UI';
    gReg.DefaultFont.Style := [];
    gReg.TopRow := 1;
    gReg.Appearance.FixedLayout.Fill.Color := 16380654;
    gReg.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gReg.Appearance.FixedLayout.Font.Color := 4539717;
    gReg.Appearance.FixedLayout.Font.Height := -13;
    gReg.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    gReg.Appearance.FixedLayout.Font.Style := [fsBold];
    gReg.Appearance.NormalLayout.Fill.Color := 16578806;
    gReg.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gReg.Appearance.NormalLayout.Font.Color := 8026746;
    gReg.Appearance.NormalLayout.Font.Height := -11;
    gReg.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    gReg.Appearance.NormalLayout.Font.Style := [];
    gReg.Appearance.GroupLayout.Fill.Color := 12817262;
    gReg.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gReg.Appearance.GroupLayout.Font.Color := clBlack;
    gReg.Appearance.GroupLayout.Font.Height := -11;
    gReg.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    gReg.Appearance.GroupLayout.Font.Style := [];
    gReg.Appearance.SummaryLayout.Fill.Color := 14009785;
    gReg.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gReg.Appearance.SummaryLayout.Font.Color := clBlack;
    gReg.Appearance.SummaryLayout.Font.Height := -11;
    gReg.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    gReg.Appearance.SummaryLayout.Font.Style := [];
    gReg.Appearance.SelectedLayout.Fill.Color := 16441019;
    gReg.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gReg.Appearance.SelectedLayout.Font.Color := 4539717;
    gReg.Appearance.SelectedLayout.Font.Height := -11;
    gReg.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    gReg.Appearance.SelectedLayout.Font.Style := [];
    gReg.Appearance.FocusedLayout.Fill.Color := 16039284;
    gReg.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gReg.Appearance.FocusedLayout.Font.Color := 4539717;
    gReg.Appearance.FocusedLayout.Font.Height := -11;
    gReg.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    gReg.Appearance.FocusedLayout.Font.Style := [];
    gReg.Appearance.FixedSelectedLayout.Fill.Color := clLightsteelblue;
    gReg.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gReg.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    gReg.Appearance.FixedSelectedLayout.Font.Height := -11;
    gReg.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gReg.Appearance.FixedSelectedLayout.Font.Style := [];
    gReg.Appearance.BandLayout.Fill.Color := 16711679;
    gReg.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gReg.Appearance.BandLayout.Font.Color := 8026746;
    gReg.Appearance.BandLayout.Font.Height := -11;
    gReg.Appearance.BandLayout.Font.Name := 'Segoe UI';
    gReg.Appearance.BandLayout.Font.Style := [];
    gReg.Appearance.ProgressLayout.Format := '%.0f%%';
    gReg.LeftCol := 0;
    gReg.ScrollMode := scmItemScrolling;
    gReg.DesignTimeSampleData := True;
    SetEvent(gReg, Self, 'OnGetCellLayout', 'gRegGetCellLayout');
    SetEvent(gReg, Self, 'OnCellClick', 'gRegCellClick');
    gdaReg.SetParentComponent(gReg);
    gdaReg.Name := 'gdaReg';
    gdaReg.Left := 96;
    gdaReg.Top := 40;
    gdaReg.Width := 26;
    gdaReg.Height := 26;
    gdaReg.Visible := True;
    gdaReg.Active := True;
    gdaReg.Grid := gReg;
    gdaReg.DataSource := dsReg;
    gdaReg.Columns.Clear;
    with gdaReg.Columns.Add do
    begin
      FieldName := 'FleetNo';
      Header := 'Fleet No';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaReg.Columns.Add do
    begin
      FieldName := 'Reg';
      Header := 'Reg No';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaReg.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Selected';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaReg.Columns.Add do
    begin
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    pMaintTypes.SetParentComponent(pMainTop);
    pMaintTypes.Name := 'pMaintTypes';
    pMaintTypes.Left := 609;
    pMaintTypes.Top := 0;
    pMaintTypes.Width := 280;
    pMaintTypes.Height := 193;
    pMaintTypes.Align := alLeft;
    pMaintTypes.ChildOrder := 3;
    pMaintTypes.TabOrder := 3;
    WebLabel4.SetParentComponent(pMaintTypes);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 0;
    WebLabel4.Top := 0;
    WebLabel4.Width := 280;
    WebLabel4.Height := 15;
    WebLabel4.Align := alTop;
    WebLabel4.Alignment := taCenter;
    WebLabel4.Caption := 'Select System Type';
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clWindowText;
    WebLabel4.Font.Height := -12;
    WebLabel4.Font.Name := 'Segoe UI';
    WebLabel4.Font.Style := [fsBold];
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.ParentFont := False;
    WebLabel4.WidthPercent := 100.000000000000000000;
    gSysTypes.SetParentComponent(pMaintTypes);
    gSysTypes.Name := 'gSysTypes';
    gSysTypes.Left := 0;
    gSysTypes.Top := 15;
    gSysTypes.Width := 280;
    gSysTypes.Height := 154;
    gSysTypes.Align := alClient;
    gSysTypes.ParentDoubleBuffered := False;
    gSysTypes.DoubleBuffered := True;
    gSysTypes.TabOrder := 0;
    gSysTypes.DefaultRowHeight := 30.000000000000000000;
    gSysTypes.FixedColumns := 0;
    gSysTypes.ColumnCount := 4;
    gSysTypes.RowCount := 1;
    gSysTypes.Options.Bands.Enabled := True;
    gSysTypes.Options.Editing.CalcFormat := '%g';
    gSysTypes.Options.Editing.Enabled := False;
    gSysTypes.Options.Grouping.CalcFormat := '%g';
    gSysTypes.Options.Grouping.GroupCountFormat := '(%d)';
    gSysTypes.Options.IO.XMLEncoding := 'ISO-8859-1';
    gSysTypes.Options.Mouse.ClickMargin := 0;
    gSysTypes.Options.Mouse.ColumnSizeMargin := 6;
    gSysTypes.Options.Mouse.RowSizeMargin := 6;
    gSysTypes.Adapter := gdaSysTypes;
    gSysTypes.Columns.Clear;
    with gSysTypes.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gSysTypes.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 140.000000000000000000;
    end;
    with gSysTypes.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gSysTypes.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 50.000000000000000000;
    end;
    gSysTypes.DefaultFont.Charset := DEFAULT_CHARSET;
    gSysTypes.DefaultFont.Color := clWindowText;
    gSysTypes.DefaultFont.Height := -11;
    gSysTypes.DefaultFont.Name := 'Segoe UI';
    gSysTypes.DefaultFont.Style := [];
    gSysTypes.TopRow := 1;
    gSysTypes.Appearance.FixedLayout.Fill.Color := 16380654;
    gSysTypes.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gSysTypes.Appearance.FixedLayout.Font.Color := 4539717;
    gSysTypes.Appearance.FixedLayout.Font.Height := -13;
    gSysTypes.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    gSysTypes.Appearance.FixedLayout.Font.Style := [fsBold];
    gSysTypes.Appearance.NormalLayout.Fill.Color := 16578806;
    gSysTypes.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gSysTypes.Appearance.NormalLayout.Font.Color := 8026746;
    gSysTypes.Appearance.NormalLayout.Font.Height := -11;
    gSysTypes.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    gSysTypes.Appearance.NormalLayout.Font.Style := [];
    gSysTypes.Appearance.GroupLayout.Fill.Color := 12817262;
    gSysTypes.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gSysTypes.Appearance.GroupLayout.Font.Color := clBlack;
    gSysTypes.Appearance.GroupLayout.Font.Height := -11;
    gSysTypes.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    gSysTypes.Appearance.GroupLayout.Font.Style := [];
    gSysTypes.Appearance.SummaryLayout.Fill.Color := 14009785;
    gSysTypes.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gSysTypes.Appearance.SummaryLayout.Font.Color := clBlack;
    gSysTypes.Appearance.SummaryLayout.Font.Height := -11;
    gSysTypes.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    gSysTypes.Appearance.SummaryLayout.Font.Style := [];
    gSysTypes.Appearance.SelectedLayout.Fill.Color := 16441019;
    gSysTypes.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gSysTypes.Appearance.SelectedLayout.Font.Color := 4539717;
    gSysTypes.Appearance.SelectedLayout.Font.Height := -11;
    gSysTypes.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    gSysTypes.Appearance.SelectedLayout.Font.Style := [];
    gSysTypes.Appearance.FocusedLayout.Fill.Color := 16039284;
    gSysTypes.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gSysTypes.Appearance.FocusedLayout.Font.Color := 4539717;
    gSysTypes.Appearance.FocusedLayout.Font.Height := -11;
    gSysTypes.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    gSysTypes.Appearance.FocusedLayout.Font.Style := [];
    gSysTypes.Appearance.FixedSelectedLayout.Fill.Color := clLightsteelblue;
    gSysTypes.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gSysTypes.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    gSysTypes.Appearance.FixedSelectedLayout.Font.Height := -11;
    gSysTypes.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gSysTypes.Appearance.FixedSelectedLayout.Font.Style := [];
    gSysTypes.Appearance.BandLayout.Fill.Color := 16711679;
    gSysTypes.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gSysTypes.Appearance.BandLayout.Font.Color := 8026746;
    gSysTypes.Appearance.BandLayout.Font.Height := -11;
    gSysTypes.Appearance.BandLayout.Font.Name := 'Segoe UI';
    gSysTypes.Appearance.BandLayout.Font.Style := [];
    gSysTypes.Appearance.ProgressLayout.Format := '%.0f%%';
    gSysTypes.LeftCol := 1;
    gSysTypes.ScrollMode := scmItemScrolling;
    gSysTypes.DesignTimeSampleData := True;
    SetEvent(gSysTypes, Self, 'OnGetCellLayout', 'gSysTypesGetCellLayout');
    SetEvent(gSysTypes, Self, 'OnCellClick', 'gSysTypesCellClick');
    gdaSysTypes.SetParentComponent(gSysTypes);
    gdaSysTypes.Name := 'gdaSysTypes';
    gdaSysTypes.Left := 22;
    gdaSysTypes.Top := 40;
    gdaSysTypes.Width := 26;
    gdaSysTypes.Height := 26;
    gdaSysTypes.Visible := True;
    gdaSysTypes.Active := True;
    gdaSysTypes.Grid := gSysTypes;
    gdaSysTypes.DataSource := dsSysTypes;
    gdaSysTypes.Columns.Clear;
    with gdaSysTypes.Columns.Add do
    begin
      FieldName := 'SysType';
      Header := 'ID';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaSysTypes.Columns.Add do
    begin
      FieldName := 'Description';
      Header := 'Name';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaSysTypes.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Selected';
      CheckFalse := 'False';
      UseLookupEditor := False;
      CheckTrue := 'True';
    end;
    with gdaSysTypes.Columns.Add do
    begin
      Header := 'Status';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    WebSpeedButton1.SetParentComponent(pMaintTypes);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 0;
    WebSpeedButton1.Top := 169;
    WebSpeedButton1.Width := 280;
    WebSpeedButton1.Height := 24;
    WebSpeedButton1.Align := alBottom;
    WebSpeedButton1.Caption := 'Clear';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 1;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    pCostGroups.SetParentComponent(pMainTop);
    pCostGroups.Name := 'pCostGroups';
    pCostGroups.Left := 889;
    pCostGroups.Top := 0;
    pCostGroups.Width := 280;
    pCostGroups.Height := 193;
    pCostGroups.Align := alLeft;
    pCostGroups.ChildOrder := 4;
    pCostGroups.TabOrder := 4;
    WebLabel5.SetParentComponent(pCostGroups);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 0;
    WebLabel5.Top := 0;
    WebLabel5.Width := 280;
    WebLabel5.Height := 15;
    WebLabel5.Align := alTop;
    WebLabel5.Alignment := taCenter;
    WebLabel5.Caption := 'Cost Groups';
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clWindowText;
    WebLabel5.Font.Height := -12;
    WebLabel5.Font.Name := 'Segoe UI';
    WebLabel5.Font.Style := [fsBold];
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.ParentFont := False;
    WebLabel5.WidthPercent := 100.000000000000000000;
    gCostGroups.SetParentComponent(pCostGroups);
    gCostGroups.Name := 'gCostGroups';
    gCostGroups.Left := 0;
    gCostGroups.Top := 15;
    gCostGroups.Width := 280;
    gCostGroups.Height := 154;
    gCostGroups.Align := alClient;
    gCostGroups.ParentDoubleBuffered := False;
    gCostGroups.DoubleBuffered := True;
    gCostGroups.TabOrder := 0;
    gCostGroups.DefaultRowHeight := 30.000000000000000000;
    gCostGroups.FixedColumns := 0;
    gCostGroups.ColumnCount := 4;
    gCostGroups.RowCount := 1;
    gCostGroups.Options.Bands.Enabled := True;
    gCostGroups.Options.Editing.CalcFormat := '%g';
    gCostGroups.Options.Grouping.CalcFormat := '%g';
    gCostGroups.Options.Grouping.GroupCountFormat := '(%d)';
    gCostGroups.Options.IO.XMLEncoding := 'ISO-8859-1';
    gCostGroups.Options.Mouse.ClickMargin := 0;
    gCostGroups.Options.Mouse.ColumnSizeMargin := 6;
    gCostGroups.Options.Mouse.RowSizeMargin := 6;
    gCostGroups.Adapter := gdaCostGroups;
    gCostGroups.Columns.Clear;
    with gCostGroups.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gCostGroups.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 140.000000000000000000;
    end;
    with gCostGroups.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gCostGroups.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 50.000000000000000000;
    end;
    gCostGroups.DefaultFont.Charset := DEFAULT_CHARSET;
    gCostGroups.DefaultFont.Color := clWindowText;
    gCostGroups.DefaultFont.Height := -11;
    gCostGroups.DefaultFont.Name := 'Segoe UI';
    gCostGroups.DefaultFont.Style := [];
    gCostGroups.TopRow := 1;
    gCostGroups.Appearance.FixedLayout.Fill.Color := 16380654;
    gCostGroups.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gCostGroups.Appearance.FixedLayout.Font.Color := 4539717;
    gCostGroups.Appearance.FixedLayout.Font.Height := -13;
    gCostGroups.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    gCostGroups.Appearance.FixedLayout.Font.Style := [fsBold];
    gCostGroups.Appearance.NormalLayout.Fill.Color := 16578806;
    gCostGroups.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gCostGroups.Appearance.NormalLayout.Font.Color := 8026746;
    gCostGroups.Appearance.NormalLayout.Font.Height := -11;
    gCostGroups.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    gCostGroups.Appearance.NormalLayout.Font.Style := [];
    gCostGroups.Appearance.GroupLayout.Fill.Color := 12817262;
    gCostGroups.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gCostGroups.Appearance.GroupLayout.Font.Color := clBlack;
    gCostGroups.Appearance.GroupLayout.Font.Height := -11;
    gCostGroups.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    gCostGroups.Appearance.GroupLayout.Font.Style := [];
    gCostGroups.Appearance.SummaryLayout.Fill.Color := 14009785;
    gCostGroups.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gCostGroups.Appearance.SummaryLayout.Font.Color := clBlack;
    gCostGroups.Appearance.SummaryLayout.Font.Height := -11;
    gCostGroups.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    gCostGroups.Appearance.SummaryLayout.Font.Style := [];
    gCostGroups.Appearance.SelectedLayout.Fill.Color := 16441019;
    gCostGroups.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gCostGroups.Appearance.SelectedLayout.Font.Color := 4539717;
    gCostGroups.Appearance.SelectedLayout.Font.Height := -11;
    gCostGroups.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    gCostGroups.Appearance.SelectedLayout.Font.Style := [];
    gCostGroups.Appearance.FocusedLayout.Fill.Color := 16039284;
    gCostGroups.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gCostGroups.Appearance.FocusedLayout.Font.Color := 4539717;
    gCostGroups.Appearance.FocusedLayout.Font.Height := -11;
    gCostGroups.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    gCostGroups.Appearance.FocusedLayout.Font.Style := [];
    gCostGroups.Appearance.FixedSelectedLayout.Fill.Color := clLightsteelblue;
    gCostGroups.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gCostGroups.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    gCostGroups.Appearance.FixedSelectedLayout.Font.Height := -11;
    gCostGroups.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gCostGroups.Appearance.FixedSelectedLayout.Font.Style := [];
    gCostGroups.Appearance.BandLayout.Fill.Color := 16711679;
    gCostGroups.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gCostGroups.Appearance.BandLayout.Font.Color := 8026746;
    gCostGroups.Appearance.BandLayout.Font.Height := -11;
    gCostGroups.Appearance.BandLayout.Font.Name := 'Segoe UI';
    gCostGroups.Appearance.BandLayout.Font.Style := [];
    gCostGroups.Appearance.ProgressLayout.Format := '%.0f%%';
    gCostGroups.LeftCol := 1;
    gCostGroups.ScrollMode := scmItemScrolling;
    gCostGroups.DesignTimeSampleData := True;
    SetEvent(gCostGroups, Self, 'OnGetCellLayout', 'gCostGroupsGetCellLayout');
    SetEvent(gCostGroups, Self, 'OnCellClick', 'gCostGroupsCellClick');
    gdaCostGroups.SetParentComponent(gCostGroups);
    gdaCostGroups.Name := 'gdaCostGroups';
    gdaCostGroups.Left := 6;
    gdaCostGroups.Top := 40;
    gdaCostGroups.Width := 26;
    gdaCostGroups.Height := 26;
    gdaCostGroups.Visible := True;
    gdaCostGroups.Active := True;
    gdaCostGroups.Grid := gCostGroups;
    gdaCostGroups.DataSource := dsCostGroups;
    gdaCostGroups.Columns.Clear;
    with gdaCostGroups.Columns.Add do
    begin
      FieldName := 'Cost';
      Header := 'ID';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaCostGroups.Columns.Add do
    begin
      FieldName := 'Description';
      Header := 'Name';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaCostGroups.Columns.Add do
    begin
      FieldName := 'Selected';
      Header := 'Selected';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaCostGroups.Columns.Add do
    begin
      Header := 'Status';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    WebSpeedButton2.SetParentComponent(pCostGroups);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 0;
    WebSpeedButton2.Top := 169;
    WebSpeedButton2.Width := 280;
    WebSpeedButton2.Height := 24;
    WebSpeedButton2.Align := alBottom;
    WebSpeedButton2.Caption := 'Clear';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 1;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebButton1.SetParentComponent(pMain);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 1226;
    WebButton1.Top := 466;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'WebButton1';
    WebButton1.ChildOrder := 1;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    wpDashSums.SetParentComponent(pMain);
    wpDashSums.Name := 'wpDashSums';
    wpDashSums.Left := 0;
    wpDashSums.Top := 193;
    wpDashSums.Width := 2000;
    wpDashSums.Height := 72;
    wpDashSums.Align := alTop;
    wpDashSums.ChildOrder := 2;
    wpDashSums.TabOrder := 2;
    wpTotalCost.SetParentComponent(wpDashSums);
    wpTotalCost.Name := 'wpTotalCost';
    wpTotalCost.Left := 57;
    wpTotalCost.Top := 0;
    wpTotalCost.Width := 150;
    wpTotalCost.Height := 72;
    wpTotalCost.Align := alLeft;
    wpTotalCost.BorderColor := clBlack;
    wpTotalCost.ChildOrder := 6;
    wpTotalCost.Color := clYellow;
    wpTotalCost.TabOrder := 0;
    WebDBLabel1.SetParentComponent(wpTotalCost);
    WebDBLabel1.Name := 'WebDBLabel1';
    WebDBLabel1.Left := 0;
    WebDBLabel1.Top := 23;
    WebDBLabel1.Width := 150;
    WebDBLabel1.Height := 23;
    WebDBLabel1.Align := alTop;
    WebDBLabel1.Alignment := taCenter;
    WebDBLabel1.Color := clYellow;
    WebDBLabel1.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel1.Font.Color := clWindowText;
    WebDBLabel1.Font.Height := -17;
    WebDBLabel1.Font.Name := 'Segoe UI';
    WebDBLabel1.Font.Style := [fsBold];
    WebDBLabel1.HeightPercent := 100.000000000000000000;
    WebDBLabel1.ParentFont := False;
    WebDBLabel1.Transparent := False;
    WebDBLabel1.WidthPercent := 100.000000000000000000;
    WebDBLabel1.DataField := 'TotalCost';
    WebDBLabel1.DataSource := dsDashBoardSums;
    WebLabel6.SetParentComponent(wpTotalCost);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 0;
    WebLabel6.Top := 0;
    WebLabel6.Width := 150;
    WebLabel6.Height := 23;
    WebLabel6.Align := alTop;
    WebLabel6.Alignment := taCenter;
    WebLabel6.Caption := 'Total';
    WebLabel6.Font.Charset := DEFAULT_CHARSET;
    WebLabel6.Font.Color := clWindowText;
    WebLabel6.Font.Height := -17;
    WebLabel6.Font.Name := 'Segoe UI';
    WebLabel6.Font.Style := [fsBold];
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.ParentFont := False;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebDBLabel10.SetParentComponent(wpTotalCost);
    WebDBLabel10.Name := 'WebDBLabel10';
    WebDBLabel10.Left := 0;
    WebDBLabel10.Top := 46;
    WebDBLabel10.Width := 150;
    WebDBLabel10.Height := 26;
    WebDBLabel10.Align := alClient;
    WebDBLabel10.Alignment := taCenter;
    WebDBLabel10.Caption := 'WebDBLabel10';
    WebDBLabel10.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel10.Font.Color := clWindowText;
    WebDBLabel10.Font.Height := -16;
    WebDBLabel10.Font.Name := 'Segoe UI';
    WebDBLabel10.Font.Style := [fsBold];
    WebDBLabel10.HeightPercent := 100.000000000000000000;
    WebDBLabel10.ParentFont := False;
    WebDBLabel10.WidthPercent := 100.000000000000000000;
    WebDBLabel10.DataField := 'TotalCPK';
    WebDBLabel10.DataSource := dsDashBoardSums;
    wpMaintenance.SetParentComponent(wpDashSums);
    wpMaintenance.Name := 'wpMaintenance';
    wpMaintenance.Left := 207;
    wpMaintenance.Top := 0;
    wpMaintenance.Width := 150;
    wpMaintenance.Height := 72;
    wpMaintenance.Align := alLeft;
    wpMaintenance.ChildOrder := 6;
    wpMaintenance.Color := clTomato;
    wpMaintenance.TabOrder := 1;
    WebLabel7.SetParentComponent(wpMaintenance);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 0;
    WebLabel7.Top := 0;
    WebLabel7.Width := 150;
    WebLabel7.Height := 23;
    WebLabel7.Align := alTop;
    WebLabel7.Alignment := taCenter;
    WebLabel7.Caption := 'Maintenance';
    WebLabel7.Font.Charset := DEFAULT_CHARSET;
    WebLabel7.Font.Color := clWindowText;
    WebLabel7.Font.Height := -17;
    WebLabel7.Font.Name := 'Segoe UI';
    WebLabel7.Font.Style := [fsBold];
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.ParentFont := False;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebDBLabel2.SetParentComponent(wpMaintenance);
    WebDBLabel2.Name := 'WebDBLabel2';
    WebDBLabel2.Left := 0;
    WebDBLabel2.Top := 23;
    WebDBLabel2.Width := 150;
    WebDBLabel2.Height := 23;
    WebDBLabel2.Align := alTop;
    WebDBLabel2.Alignment := taCenter;
    WebDBLabel2.Color := clTomato;
    WebDBLabel2.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel2.Font.Color := clWindowText;
    WebDBLabel2.Font.Height := -17;
    WebDBLabel2.Font.Name := 'Segoe UI';
    WebDBLabel2.Font.Style := [fsBold];
    WebDBLabel2.HeightPercent := 100.000000000000000000;
    WebDBLabel2.ParentFont := False;
    WebDBLabel2.Transparent := False;
    WebDBLabel2.WidthPercent := 100.000000000000000000;
    WebDBLabel2.DataField := 'MaintenanceCost';
    WebDBLabel2.DataSource := dsDashBoardSums;
    WebDBLabel11.SetParentComponent(wpMaintenance);
    WebDBLabel11.Name := 'WebDBLabel11';
    WebDBLabel11.Left := 0;
    WebDBLabel11.Top := 46;
    WebDBLabel11.Width := 150;
    WebDBLabel11.Height := 26;
    WebDBLabel11.Align := alClient;
    WebDBLabel11.Alignment := taCenter;
    WebDBLabel11.Caption := 'WebDBLabel11';
    WebDBLabel11.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel11.Font.Color := clWindowText;
    WebDBLabel11.Font.Height := -16;
    WebDBLabel11.Font.Name := 'Segoe UI';
    WebDBLabel11.Font.Style := [fsBold];
    WebDBLabel11.HeightPercent := 100.000000000000000000;
    WebDBLabel11.ParentFont := False;
    WebDBLabel11.WidthPercent := 100.000000000000000000;
    WebDBLabel11.DataField := 'MaintenanceCPK';
    WebDBLabel11.DataSource := dsDashBoardSums;
    wpTyres.SetParentComponent(wpDashSums);
    wpTyres.Name := 'wpTyres';
    wpTyres.Left := 357;
    wpTyres.Top := 0;
    wpTyres.Width := 150;
    wpTyres.Height := 72;
    wpTyres.Align := alLeft;
    wpTyres.BorderColor := clAqua;
    wpTyres.ChildOrder := 6;
    wpTyres.Color := clAqua;
    wpTyres.TabOrder := 2;
    WebDBLabel5.SetParentComponent(wpTyres);
    WebDBLabel5.Name := 'WebDBLabel5';
    WebDBLabel5.Left := 0;
    WebDBLabel5.Top := 23;
    WebDBLabel5.Width := 150;
    WebDBLabel5.Height := 23;
    WebDBLabel5.Align := alTop;
    WebDBLabel5.Alignment := taCenter;
    WebDBLabel5.Color := clAqua;
    WebDBLabel5.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel5.Font.Color := clWindowText;
    WebDBLabel5.Font.Height := -17;
    WebDBLabel5.Font.Name := 'Segoe UI';
    WebDBLabel5.Font.Style := [fsBold];
    WebDBLabel5.HeightPercent := 100.000000000000000000;
    WebDBLabel5.ParentFont := False;
    WebDBLabel5.Transparent := False;
    WebDBLabel5.WidthPercent := 100.000000000000000000;
    WebDBLabel5.DataField := 'TyreCost';
    WebDBLabel5.DataSource := dsDashBoardSums;
    WebLabel8.SetParentComponent(wpTyres);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 0;
    WebLabel8.Top := 0;
    WebLabel8.Width := 150;
    WebLabel8.Height := 23;
    WebLabel8.Align := alTop;
    WebLabel8.Alignment := taCenter;
    WebLabel8.Caption := 'Tyre';
    WebLabel8.Color := clAqua;
    WebLabel8.Font.Charset := DEFAULT_CHARSET;
    WebLabel8.Font.Color := clWindowText;
    WebLabel8.Font.Height := -17;
    WebLabel8.Font.Name := 'Segoe UI';
    WebLabel8.Font.Style := [fsBold];
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.ParentFont := False;
    WebLabel8.Transparent := False;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebDBLabel12.SetParentComponent(wpTyres);
    WebDBLabel12.Name := 'WebDBLabel12';
    WebDBLabel12.Left := 0;
    WebDBLabel12.Top := 46;
    WebDBLabel12.Width := 150;
    WebDBLabel12.Height := 26;
    WebDBLabel12.Align := alClient;
    WebDBLabel12.Alignment := taCenter;
    WebDBLabel12.Caption := 'WebDBLabel12';
    WebDBLabel12.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel12.Font.Color := clWindowText;
    WebDBLabel12.Font.Height := -16;
    WebDBLabel12.Font.Name := 'Segoe UI';
    WebDBLabel12.Font.Style := [fsBold];
    WebDBLabel12.HeightPercent := 100.000000000000000000;
    WebDBLabel12.ParentFont := False;
    WebDBLabel12.WidthPercent := 100.000000000000000000;
    WebDBLabel12.DataField := 'TyreCPK';
    WebDBLabel12.DataSource := dsDashBoardSums;
    wpCost.SetParentComponent(wpDashSums);
    wpCost.Name := 'wpCost';
    wpCost.Left := 507;
    wpCost.Top := 0;
    wpCost.Width := 150;
    wpCost.Height := 72;
    wpCost.Align := alLeft;
    wpCost.ChildOrder := 7;
    wpCost.Color := clFuchsia;
    wpCost.TabOrder := 3;
    WebDBLabel3.SetParentComponent(wpCost);
    WebDBLabel3.Name := 'WebDBLabel3';
    WebDBLabel3.Left := 0;
    WebDBLabel3.Top := 23;
    WebDBLabel3.Width := 150;
    WebDBLabel3.Height := 23;
    WebDBLabel3.Align := alTop;
    WebDBLabel3.Alignment := taCenter;
    WebDBLabel3.Color := clFuchsia;
    WebDBLabel3.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel3.Font.Color := clWindowText;
    WebDBLabel3.Font.Height := -17;
    WebDBLabel3.Font.Name := 'Segoe UI';
    WebDBLabel3.Font.Style := [fsBold];
    WebDBLabel3.HeightPercent := 100.000000000000000000;
    WebDBLabel3.ParentFont := False;
    WebDBLabel3.WidthPercent := 100.000000000000000000;
    WebDBLabel3.DataField := 'WashCost';
    WebDBLabel3.DataSource := dsDashBoardSums;
    WebLabel9.SetParentComponent(wpCost);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 0;
    WebLabel9.Top := 0;
    WebLabel9.Width := 150;
    WebLabel9.Height := 23;
    WebLabel9.Align := alTop;
    WebLabel9.Alignment := taCenter;
    WebLabel9.Caption := 'Wash';
    WebLabel9.Font.Charset := DEFAULT_CHARSET;
    WebLabel9.Font.Color := clWindowText;
    WebLabel9.Font.Height := -17;
    WebLabel9.Font.Name := 'Segoe UI';
    WebLabel9.Font.Style := [fsBold];
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.ParentFont := False;
    WebLabel9.WidthPercent := 100.000000000000000000;
    WebDBLabel9.SetParentComponent(wpCost);
    WebDBLabel9.Name := 'WebDBLabel9';
    WebDBLabel9.Left := 0;
    WebDBLabel9.Top := 46;
    WebDBLabel9.Width := 150;
    WebDBLabel9.Height := 26;
    WebDBLabel9.Align := alClient;
    WebDBLabel9.Alignment := taCenter;
    WebDBLabel9.Caption := 'WebDBLabel9';
    WebDBLabel9.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel9.Font.Color := clWindowText;
    WebDBLabel9.Font.Height := -16;
    WebDBLabel9.Font.Name := 'Segoe UI';
    WebDBLabel9.Font.Style := [fsBold];
    WebDBLabel9.HeightPercent := 100.000000000000000000;
    WebDBLabel9.ParentFont := False;
    WebDBLabel9.WidthPercent := 100.000000000000000000;
    WebDBLabel9.DataField := 'WashCPK';
    WebDBLabel9.DataSource := dsDashBoardSums;
    wpInsurance.SetParentComponent(wpDashSums);
    wpInsurance.Name := 'wpInsurance';
    wpInsurance.Left := 657;
    wpInsurance.Top := 0;
    wpInsurance.Width := 150;
    wpInsurance.Height := 72;
    wpInsurance.Align := alLeft;
    wpInsurance.ChildOrder := 8;
    wpInsurance.Color := clLime;
    wpInsurance.TabOrder := 4;
    WebDBLabel4.SetParentComponent(wpInsurance);
    WebDBLabel4.Name := 'WebDBLabel4';
    WebDBLabel4.Left := 0;
    WebDBLabel4.Top := 23;
    WebDBLabel4.Width := 150;
    WebDBLabel4.Height := 24;
    WebDBLabel4.Align := alTop;
    WebDBLabel4.Alignment := taCenter;
    WebDBLabel4.AutoSize := False;
    WebDBLabel4.Color := clLime;
    WebDBLabel4.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel4.Font.Color := clWindowText;
    WebDBLabel4.Font.Height := -17;
    WebDBLabel4.Font.Name := 'Segoe UI';
    WebDBLabel4.Font.Style := [fsBold];
    WebDBLabel4.HeightPercent := 100.000000000000000000;
    WebDBLabel4.ParentFont := False;
    WebDBLabel4.WidthPercent := 100.000000000000000000;
    WebDBLabel4.DataField := 'InsuranceCost';
    WebDBLabel4.DataSource := dsDashBoardSums;
    WebLabel10.SetParentComponent(wpInsurance);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 0;
    WebLabel10.Top := 0;
    WebLabel10.Width := 150;
    WebLabel10.Height := 23;
    WebLabel10.Align := alTop;
    WebLabel10.Alignment := taCenter;
    WebLabel10.Caption := 'Insurance';
    WebLabel10.Font.Charset := DEFAULT_CHARSET;
    WebLabel10.Font.Color := clWindowText;
    WebLabel10.Font.Height := -17;
    WebLabel10.Font.Name := 'Segoe UI';
    WebLabel10.Font.Style := [fsBold];
    WebLabel10.HeightPercent := 100.000000000000000000;
    WebLabel10.ParentFont := False;
    WebLabel10.WidthPercent := 100.000000000000000000;
    WebDBLabel13.SetParentComponent(wpInsurance);
    WebDBLabel13.Name := 'WebDBLabel13';
    WebDBLabel13.Left := 0;
    WebDBLabel13.Top := 47;
    WebDBLabel13.Width := 150;
    WebDBLabel13.Height := 25;
    WebDBLabel13.Align := alClient;
    WebDBLabel13.Alignment := taCenter;
    WebDBLabel13.Caption := 'WebDBLabel13';
    WebDBLabel13.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel13.Font.Color := clWindowText;
    WebDBLabel13.Font.Height := -16;
    WebDBLabel13.Font.Name := 'Segoe UI';
    WebDBLabel13.Font.Style := [fsBold];
    WebDBLabel13.HeightPercent := 100.000000000000000000;
    WebDBLabel13.ParentFont := False;
    WebDBLabel13.WidthPercent := 100.000000000000000000;
    WebDBLabel13.DataField := 'InsuranceCPK';
    WebDBLabel13.DataSource := dsDashBoardSums;
    wpOperational.SetParentComponent(wpDashSums);
    wpOperational.Name := 'wpOperational';
    wpOperational.Left := 807;
    wpOperational.Top := 0;
    wpOperational.Width := 150;
    wpOperational.Height := 72;
    wpOperational.Align := alLeft;
    wpOperational.ChildOrder := 9;
    wpOperational.Color := clTeal;
    wpOperational.TabOrder := 5;
    WebDBLabel6.SetParentComponent(wpOperational);
    WebDBLabel6.Name := 'WebDBLabel6';
    WebDBLabel6.Left := 0;
    WebDBLabel6.Top := 23;
    WebDBLabel6.Width := 150;
    WebDBLabel6.Height := 24;
    WebDBLabel6.Align := alTop;
    WebDBLabel6.Alignment := taCenter;
    WebDBLabel6.AutoSize := False;
    WebDBLabel6.Color := clTeal;
    WebDBLabel6.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel6.Font.Color := clWindowText;
    WebDBLabel6.Font.Height := -17;
    WebDBLabel6.Font.Name := 'Segoe UI';
    WebDBLabel6.Font.Style := [fsBold];
    WebDBLabel6.HeightPercent := 100.000000000000000000;
    WebDBLabel6.ParentFont := False;
    WebDBLabel6.WidthPercent := 100.000000000000000000;
    WebDBLabel6.DataField := 'OtherCost';
    WebDBLabel6.DataSource := dsDashBoardSums;
    WebLabel11.SetParentComponent(wpOperational);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 0;
    WebLabel11.Top := 0;
    WebLabel11.Width := 150;
    WebLabel11.Height := 23;
    WebLabel11.Align := alTop;
    WebLabel11.Alignment := taCenter;
    WebLabel11.Caption := 'Operational';
    WebLabel11.Font.Charset := DEFAULT_CHARSET;
    WebLabel11.Font.Color := clWindowText;
    WebLabel11.Font.Height := -17;
    WebLabel11.Font.Name := 'Segoe UI';
    WebLabel11.Font.Style := [fsBold];
    WebLabel11.HeightPercent := 100.000000000000000000;
    WebLabel11.ParentFont := False;
    WebLabel11.WidthPercent := 100.000000000000000000;
    WebDBLabel14.SetParentComponent(wpOperational);
    WebDBLabel14.Name := 'WebDBLabel14';
    WebDBLabel14.Left := 0;
    WebDBLabel14.Top := 47;
    WebDBLabel14.Width := 150;
    WebDBLabel14.Height := 25;
    WebDBLabel14.Align := alClient;
    WebDBLabel14.Alignment := taCenter;
    WebDBLabel14.Caption := 'WebDBLabel14';
    WebDBLabel14.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel14.Font.Color := clWindowText;
    WebDBLabel14.Font.Height := -16;
    WebDBLabel14.Font.Name := 'Segoe UI';
    WebDBLabel14.Font.Style := [fsBold];
    WebDBLabel14.HeightPercent := 100.000000000000000000;
    WebDBLabel14.ParentFont := False;
    WebDBLabel14.WidthPercent := 100.000000000000000000;
    WebDBLabel14.DataField := 'OtherCPK';
    WebDBLabel14.DataSource := dsDashBoardSums;
    wbSearch.SetParentComponent(wpDashSums);
    wbSearch.Name := 'wbSearch';
    wbSearch.Left := 1407;
    wbSearch.Top := 0;
    wbSearch.Width := 96;
    wbSearch.Height := 72;
    wbSearch.Align := alLeft;
    wbSearch.Caption := 'Search';
    wbSearch.ChildOrder := 5;
    wbSearch.HeightPercent := 100.000000000000000000;
    wbSearch.WidthPercent := 100.000000000000000000;
    SetEvent(wbSearch, Self, 'OnClick', 'wbSearchClick');
    wpCapex.SetParentComponent(wpDashSums);
    wpCapex.Name := 'wpCapex';
    wpCapex.Left := 957;
    wpCapex.Top := 0;
    wpCapex.Width := 150;
    wpCapex.Height := 72;
    wpCapex.Align := alLeft;
    wpCapex.ChildOrder := 7;
    wpCapex.Color := clGoldenrod;
    wpCapex.TabOrder := 7;
    WebLabel13.SetParentComponent(wpCapex);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 0;
    WebLabel13.Top := 0;
    WebLabel13.Width := 150;
    WebLabel13.Height := 23;
    WebLabel13.Align := alTop;
    WebLabel13.Alignment := taCenter;
    WebLabel13.Caption := 'Capex';
    WebLabel13.Font.Charset := DEFAULT_CHARSET;
    WebLabel13.Font.Color := clWindowText;
    WebLabel13.Font.Height := -17;
    WebLabel13.Font.Name := 'Segoe UI';
    WebLabel13.Font.Style := [fsBold];
    WebLabel13.HeightPercent := 100.000000000000000000;
    WebLabel13.ParentFont := False;
    WebLabel13.WidthPercent := 100.000000000000000000;
    WebDBLabel7.SetParentComponent(wpCapex);
    WebDBLabel7.Name := 'WebDBLabel7';
    WebDBLabel7.Left := 0;
    WebDBLabel7.Top := 23;
    WebDBLabel7.Width := 150;
    WebDBLabel7.Height := 24;
    WebDBLabel7.Align := alTop;
    WebDBLabel7.Alignment := taCenter;
    WebDBLabel7.AutoSize := False;
    WebDBLabel7.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel7.Font.Color := clWindowText;
    WebDBLabel7.Font.Height := -17;
    WebDBLabel7.Font.Name := 'Segoe UI';
    WebDBLabel7.Font.Style := [fsBold];
    WebDBLabel7.HeightPercent := 100.000000000000000000;
    WebDBLabel7.ParentFont := False;
    WebDBLabel7.WidthPercent := 100.000000000000000000;
    WebDBLabel7.DataField := 'CapexCost';
    WebDBLabel7.DataSource := dsDashBoardSums;
    WebDBLabel15.SetParentComponent(wpCapex);
    WebDBLabel15.Name := 'WebDBLabel15';
    WebDBLabel15.Left := 0;
    WebDBLabel15.Top := 47;
    WebDBLabel15.Width := 150;
    WebDBLabel15.Height := 25;
    WebDBLabel15.Align := alClient;
    WebDBLabel15.Alignment := taCenter;
    WebDBLabel15.Caption := 'WebDBLabel15';
    WebDBLabel15.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel15.Font.Color := clWindowText;
    WebDBLabel15.Font.Height := -16;
    WebDBLabel15.Font.Name := 'Segoe UI';
    WebDBLabel15.Font.Style := [fsBold];
    WebDBLabel15.HeightPercent := 100.000000000000000000;
    WebDBLabel15.ParentFont := False;
    WebDBLabel15.WidthPercent := 100.000000000000000000;
    WebDBLabel15.DataField := 'CapexCPK';
    WebDBLabel15.DataSource := dsDashBoardSums;
    wpUnAll.SetParentComponent(wpDashSums);
    wpUnAll.Name := 'wpUnAll';
    wpUnAll.Left := 1107;
    wpUnAll.Top := 0;
    wpUnAll.Width := 150;
    wpUnAll.Height := 72;
    wpUnAll.Align := alLeft;
    wpUnAll.ChildOrder := 8;
    wpUnAll.Color := clChocolate;
    wpUnAll.TabOrder := 8;
    WebLabel14.SetParentComponent(wpUnAll);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 0;
    WebLabel14.Top := 0;
    WebLabel14.Width := 150;
    WebLabel14.Height := 23;
    WebLabel14.Align := alTop;
    WebLabel14.Alignment := taCenter;
    WebLabel14.Caption := 'Unallocated';
    WebLabel14.Font.Charset := DEFAULT_CHARSET;
    WebLabel14.Font.Color := clWindowText;
    WebLabel14.Font.Height := -17;
    WebLabel14.Font.Name := 'Segoe UI';
    WebLabel14.Font.Style := [fsBold];
    WebLabel14.HeightPercent := 100.000000000000000000;
    WebLabel14.ParentFont := False;
    WebLabel14.WidthPercent := 100.000000000000000000;
    WebDBLabel8.SetParentComponent(wpUnAll);
    WebDBLabel8.Name := 'WebDBLabel8';
    WebDBLabel8.Left := 0;
    WebDBLabel8.Top := 23;
    WebDBLabel8.Width := 150;
    WebDBLabel8.Height := 24;
    WebDBLabel8.Align := alTop;
    WebDBLabel8.Alignment := taCenter;
    WebDBLabel8.AutoSize := False;
    WebDBLabel8.Color := clChartreuse;
    WebDBLabel8.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel8.Font.Color := clWindowText;
    WebDBLabel8.Font.Height := -17;
    WebDBLabel8.Font.Name := 'Segoe UI';
    WebDBLabel8.Font.Style := [fsBold];
    WebDBLabel8.HeightPercent := 100.000000000000000000;
    WebDBLabel8.ParentFont := False;
    WebDBLabel8.WidthPercent := 100.000000000000000000;
    WebDBLabel8.DataField := 'UnallCost';
    WebDBLabel8.DataSource := dsDashBoardSums;
    WebDBLabel16.SetParentComponent(wpUnAll);
    WebDBLabel16.Name := 'WebDBLabel16';
    WebDBLabel16.Left := 0;
    WebDBLabel16.Top := 47;
    WebDBLabel16.Width := 150;
    WebDBLabel16.Height := 21;
    WebDBLabel16.Align := alTop;
    WebDBLabel16.Alignment := taCenter;
    WebDBLabel16.Caption := 'WebDBLabel16';
    WebDBLabel16.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel16.Font.Color := clWindowText;
    WebDBLabel16.Font.Height := -16;
    WebDBLabel16.Font.Name := 'Segoe UI';
    WebDBLabel16.Font.Style := [fsBold];
    WebDBLabel16.HeightPercent := 100.000000000000000000;
    WebDBLabel16.ParentFont := False;
    WebDBLabel16.WidthPercent := 100.000000000000000000;
    WebDBLabel16.DataField := 'UnallCPK';
    WebDBLabel16.DataSource := dsDashBoardSums;
    WebPanel1.SetParentComponent(wpDashSums);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 57;
    WebPanel1.Height := 72;
    WebPanel1.Align := alLeft;
    WebPanel1.ChildOrder := 9;
    WebPanel1.TabOrder := 9;
    WebLabel12.SetParentComponent(WebPanel1);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 0;
    WebLabel12.Top := 0;
    WebLabel12.Width := 57;
    WebLabel12.Height := 15;
    WebLabel12.Align := alTop;
    WebLabel12.HeightPercent := 100.000000000000000000;
    WebLabel12.WidthPercent := 100.000000000000000000;
    WebLabel15.SetParentComponent(WebPanel1);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 0;
    WebLabel15.Top := 15;
    WebLabel15.Width := 57;
    WebLabel15.Height := 21;
    WebLabel15.Align := alTop;
    WebLabel15.Alignment := taRightJustify;
    WebLabel15.Caption := 'Cost : ';
    WebLabel15.Font.Charset := DEFAULT_CHARSET;
    WebLabel15.Font.Color := clWindowText;
    WebLabel15.Font.Height := -16;
    WebLabel15.Font.Name := 'Segoe UI';
    WebLabel15.Font.Style := [fsBold];
    WebLabel15.HeightPercent := 100.000000000000000000;
    WebLabel15.ParentFont := False;
    WebLabel15.WidthPercent := 100.000000000000000000;
    WebLabel16.SetParentComponent(WebPanel1);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 0;
    WebLabel16.Top := 36;
    WebLabel16.Width := 57;
    WebLabel16.Height := 21;
    WebLabel16.Align := alTop;
    WebLabel16.Alignment := taRightJustify;
    WebLabel16.Caption := 'CPK : ';
    WebLabel16.Font.Charset := DEFAULT_CHARSET;
    WebLabel16.Font.Color := clWindowText;
    WebLabel16.Font.Height := -16;
    WebLabel16.Font.Name := 'Segoe UI';
    WebLabel16.Font.Style := [fsBold];
    WebLabel16.HeightPercent := 100.000000000000000000;
    WebLabel16.ParentFont := False;
    WebLabel16.WidthPercent := 100.000000000000000000;
    wbExcel.SetParentComponent(wpDashSums);
    wbExcel.Name := 'wbExcel';
    wbExcel.Left := 1503;
    wbExcel.Top := 0;
    wbExcel.Width := 96;
    wbExcel.Height := 72;
    wbExcel.Align := alLeft;
    wbExcel.Caption := 'Excel Export';
    wbExcel.ChildOrder := 10;
    wbExcel.HeightPercent := 100.000000000000000000;
    wbExcel.WidthPercent := 100.000000000000000000;
    SetEvent(wbExcel, Self, 'OnClick', 'wbExcelClick');
    wpNoLink.SetParentComponent(wpDashSums);
    wpNoLink.Name := 'wpNoLink';
    wpNoLink.Left := 1257;
    wpNoLink.Top := 0;
    wpNoLink.Width := 150;
    wpNoLink.Height := 72;
    wpNoLink.Align := alLeft;
    wpNoLink.ChildOrder := 11;
    wpNoLink.TabOrder := 11;
    WebLabel17.SetParentComponent(wpNoLink);
    WebLabel17.Name := 'WebLabel17';
    WebLabel17.Left := 0;
    WebLabel17.Top := 0;
    WebLabel17.Width := 150;
    WebLabel17.Height := 26;
    WebLabel17.Align := alTop;
    WebLabel17.Alignment := taCenter;
    WebLabel17.Caption := 'Not linked';
    WebLabel17.Color := clCornflowerblue;
    WebLabel17.Font.Charset := DEFAULT_CHARSET;
    WebLabel17.Font.Color := clWindowText;
    WebLabel17.Font.Height := -17;
    WebLabel17.Font.Name := 'Segoe UI';
    WebLabel17.Font.Style := [fsBold];
    WebLabel17.HeightPercent := 100.000000000000000000;
    WebLabel17.ParentFont := False;
    WebLabel17.Transparent := False;
    WebLabel17.WidthPercent := 100.000000000000000000;
    WebDBLabel17.SetParentComponent(wpNoLink);
    WebDBLabel17.Name := 'WebDBLabel17';
    WebDBLabel17.Left := 0;
    WebDBLabel17.Top := 26;
    WebDBLabel17.Width := 150;
    WebDBLabel17.Height := 23;
    WebDBLabel17.Align := alTop;
    WebDBLabel17.Alignment := taCenter;
    WebDBLabel17.Color := clCornflowerblue;
    WebDBLabel17.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel17.Font.Color := clWindowText;
    WebDBLabel17.Font.Height := -17;
    WebDBLabel17.Font.Name := 'Segoe UI';
    WebDBLabel17.Font.Style := [fsBold];
    WebDBLabel17.HeightPercent := 100.000000000000000000;
    WebDBLabel17.ParentFont := False;
    WebDBLabel17.Transparent := False;
    WebDBLabel17.WidthPercent := 100.000000000000000000;
    WebDBLabel17.DataField := 'NotLinkedCost';
    WebDBLabel17.DataSource := dsDashBoardSums;
    WebDBLabel18.SetParentComponent(wpNoLink);
    WebDBLabel18.Name := 'WebDBLabel18';
    WebDBLabel18.Left := 0;
    WebDBLabel18.Top := 49;
    WebDBLabel18.Width := 150;
    WebDBLabel18.Height := 21;
    WebDBLabel18.Align := alTop;
    WebDBLabel18.Alignment := taCenter;
    WebDBLabel18.Caption := 'WebDBLabel18';
    WebDBLabel18.Color := clCornflowerblue;
    WebDBLabel18.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel18.Font.Color := clWindowText;
    WebDBLabel18.Font.Height := -16;
    WebDBLabel18.Font.Name := 'Segoe UI';
    WebDBLabel18.Font.Style := [fsBold];
    WebDBLabel18.HeightPercent := 100.000000000000000000;
    WebDBLabel18.ParentFont := False;
    WebDBLabel18.Transparent := False;
    WebDBLabel18.WidthPercent := 100.000000000000000000;
    WebDBLabel18.DataField := 'NotLinkedCPK';
    WebDBLabel18.DataSource := dsDashBoardSums;
    pDashData.SetParentComponent(pMain);
    pDashData.Name := 'pDashData';
    pDashData.Left := 0;
    pDashData.Top := 265;
    pDashData.Width := 2000;
    pDashData.Height := 232;
    pDashData.WidthStyle := ssPercent;
    pDashData.WidthPercent := 99.000000000000000000;
    pDashData.Align := alClient;
    pDashData.Caption := 'pDashData';
    pDashData.ChildOrder := 3;
    pDashData.TabOrder := 3;
    gDashData.SetParentComponent(pDashData);
    gDashData.Name := 'gDashData';
    gDashData.Left := 0;
    gDashData.Top := 0;
    gDashData.Width := 2000;
    gDashData.Height := 232;
    gDashData.AdaptToStyle := True;
    gDashData.Align := alClient;
    gDashData.ParentDoubleBuffered := False;
    gDashData.DoubleBuffered := True;
    gDashData.TabOrder := 0;
    gDashData.DefaultRowHeight := 25.000000000000000000;
    gDashData.FixedColumns := 0;
    gDashData.ColumnCount := 14;
    gDashData.RowCount := 1;
    SetEvent(gDashData, Self, 'OnSortFormat', 'gDashDataSortFormat');
    gDashData.Options.Bands.Enabled := True;
    gDashData.Options.Clipboard.Enabled := False;
    gDashData.Options.Editing.CalcFormat := '%g';
    gDashData.Options.Grouping.CalcFormat := '%g';
    gDashData.Options.Grouping.GroupCountFormat := '(%d)';
    gDashData.Options.IO.XMLEncoding := 'ISO-8859-1';
    gDashData.Options.Lookup.Enabled := True;
    gDashData.Options.Mouse.ClickMargin := 0;
    gDashData.Options.Mouse.ColumnSizeMargin := 6;
    gDashData.Options.Mouse.RowSizeMargin := 6;
    gDashData.Options.Sorting.Mode := gsmNormal;
    gDashData.Adapter := gdaDashData;
    gDashData.Columns.Clear;
    with gDashData.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 75.000000000000000000;
    end;
    with gDashData.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 75.000000000000000000;
    end;
    with gDashData.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 100.000000000000000000;
    end;
    with gDashData.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 50.000000000000000000;
    end;
    with gDashData.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 75.000000000000000000;
    end;
    with gDashData.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 100.000000000000000000;
    end;
    with gDashData.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 100.000000000000000000;
    end;
    with gDashData.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 50.000000000000000000;
    end;
    with gDashData.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 200.000000000000000000;
    end;
    with gDashData.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 400.000000000000000000;
    end;
    with gDashData.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 75.000000000000000000;
    end;
    with gDashData.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 100.000000000000000000;
    end;
    with gDashData.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 150.000000000000000000;
    end;
    with gDashData.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      ReadOnly := True;
      Width := 500.000000000000000000;
    end;
    gDashData.DefaultFont.Charset := DEFAULT_CHARSET;
    gDashData.DefaultFont.Color := clBlack;
    gDashData.DefaultFont.Height := -11;
    gDashData.DefaultFont.Name := 'Segoe UI';
    gDashData.DefaultFont.Style := [];
    gDashData.Stroke.Color := 15987699;
    gDashData.TopRow := 1;
    gDashData.Appearance.FixedLayout.Fill.Kind := gfkGradient;
    gDashData.Appearance.FixedLayout.Fill.Color := 16382457;
    gDashData.Appearance.FixedLayout.Fill.ColorTo := 16382457;
    gDashData.Appearance.FixedLayout.Stroke.Color := 15987699;
    gDashData.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gDashData.Appearance.FixedLayout.Font.Color := clBlack;
    gDashData.Appearance.FixedLayout.Font.Height := -13;
    gDashData.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    gDashData.Appearance.FixedLayout.Font.Style := [fsBold];
    gDashData.Appearance.NormalLayout.Fill.Color := 16578806;
    gDashData.Appearance.NormalLayout.Stroke.Color := 15987699;
    gDashData.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gDashData.Appearance.NormalLayout.Font.Color := clBlack;
    gDashData.Appearance.NormalLayout.Font.Height := -11;
    gDashData.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    gDashData.Appearance.NormalLayout.Font.Style := [];
    gDashData.Appearance.GroupLayout.Fill.Kind := gfkGradient;
    gDashData.Appearance.GroupLayout.Fill.Color := 15385233;
    gDashData.Appearance.GroupLayout.Fill.ColorTo := 15385233;
    gDashData.Appearance.GroupLayout.Stroke.Color := 15987699;
    gDashData.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gDashData.Appearance.GroupLayout.Font.Color := clBlack;
    gDashData.Appearance.GroupLayout.Font.Height := -11;
    gDashData.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    gDashData.Appearance.GroupLayout.Font.Style := [];
    gDashData.Appearance.SummaryLayout.Fill.Kind := gfkGradient;
    gDashData.Appearance.SummaryLayout.Fill.Color := 15385233;
    gDashData.Appearance.SummaryLayout.Fill.ColorTo := 15385233;
    gDashData.Appearance.SummaryLayout.Stroke.Color := 15987699;
    gDashData.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gDashData.Appearance.SummaryLayout.Font.Color := clBlack;
    gDashData.Appearance.SummaryLayout.Font.Height := -11;
    gDashData.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    gDashData.Appearance.SummaryLayout.Font.Style := [];
    gDashData.Appearance.SelectedLayout.Fill.Kind := gfkGradient;
    gDashData.Appearance.SelectedLayout.Fill.Color := 15385233;
    gDashData.Appearance.SelectedLayout.Fill.ColorTo := 15385233;
    gDashData.Appearance.SelectedLayout.Stroke.Color := 15987699;
    gDashData.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gDashData.Appearance.SelectedLayout.Font.Color := clBlack;
    gDashData.Appearance.SelectedLayout.Font.Height := -11;
    gDashData.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    gDashData.Appearance.SelectedLayout.Font.Style := [];
    gDashData.Appearance.FocusedLayout.Fill.Kind := gfkGradient;
    gDashData.Appearance.FocusedLayout.Fill.Color := 15385233;
    gDashData.Appearance.FocusedLayout.Fill.ColorTo := 15385233;
    gDashData.Appearance.FocusedLayout.Stroke.Color := 15987699;
    gDashData.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gDashData.Appearance.FocusedLayout.Font.Color := clBlack;
    gDashData.Appearance.FocusedLayout.Font.Height := -11;
    gDashData.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    gDashData.Appearance.FocusedLayout.Font.Style := [];
    gDashData.Appearance.FixedSelectedLayout.Fill.Kind := gfkGradient;
    gDashData.Appearance.FixedSelectedLayout.Fill.Color := 15385233;
    gDashData.Appearance.FixedSelectedLayout.Fill.ColorTo := 15385233;
    gDashData.Appearance.FixedSelectedLayout.Stroke.Color := 15987699;
    gDashData.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gDashData.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    gDashData.Appearance.FixedSelectedLayout.Font.Height := -11;
    gDashData.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gDashData.Appearance.FixedSelectedLayout.Font.Style := [];
    gDashData.Appearance.BandLayout.Fill.Color := 16711679;
    gDashData.Appearance.BandLayout.Stroke.Color := 15987699;
    gDashData.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gDashData.Appearance.BandLayout.Font.Color := 8026746;
    gDashData.Appearance.BandLayout.Font.Height := -11;
    gDashData.Appearance.BandLayout.Font.Name := 'Segoe UI';
    gDashData.Appearance.BandLayout.Font.Style := [];
    gDashData.Appearance.ProgressLayout.Color := 15385233;
    gDashData.Appearance.ProgressLayout.Format := '%.0f%%';
    gDashData.LeftCol := 2;
    gDashData.ScrollMode := scmItemScrolling;
    gDashData.FreezeColumns := 1;
    gDashData.DesignTimeSampleData := True;
    gdaDashData.SetParentComponent(gDashData);
    gdaDashData.Name := 'gdaDashData';
    gdaDashData.Left := 161;
    gdaDashData.Top := 24;
    gdaDashData.Width := 26;
    gdaDashData.Height := 26;
    gdaDashData.Visible := True;
    gdaDashData.Active := True;
    gdaDashData.Grid := gDashData;
    gdaDashData.DataSource := dsDashData;
    gdaDashData.Columns.Clear;
    with gdaDashData.Columns.Add do
    begin
      FieldName := 'VehType';
      Header := 'Vehicle Type';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashData.Columns.Add do
    begin
      FieldName := 'TFleetNo';
      Header := 'Fleet';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashData.Columns.Add do
    begin
      FieldName := 'JobDate';
      Header := 'Jobcard Date';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashData.Columns.Add do
    begin
      FieldName := 'JobcardNo';
      Header := 'Job No';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashData.Columns.Add do
    begin
      FieldName := 'OrderNo';
      Header := 'Order No';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashData.Columns.Add do
    begin
      FieldName := 'ReferenceNo';
      Header := 'Ref No';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashData.Columns.Add do
    begin
      FieldName := 'Category';
      Header := 'Cost Category';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashData.Columns.Add do
    begin
      FieldName := 'GlCode';
      Header := 'Gl Code';
      CheckFalse := 'False';
      UseLookupEditor := False;
      CheckTrue := 'True';
    end;
    with gdaDashData.Columns.Add do
    begin
      FieldName := 'CostDescription';
      Header := 'Cost Description';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashData.Columns.Add do
    begin
      FieldName := 'StockDescription';
      Header := 'Stock Description';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashData.Columns.Add do
    begin
      FieldName := 'TotalExcl';
      Header := 'Total Excl';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashData.Columns.Add do
    begin
      FieldName := 'JobType';
      Header := 'Job Type';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashData.Columns.Add do
    begin
      FieldName := 'Supplier';
      Header := 'Supplier';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaDashData.Columns.Add do
    begin
      FieldName := 'Reason';
      Header := 'Comment';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    gdaDashData.AutoCreateColumns := False;
    WebWaitMessage1.SetParentComponent(gDashData);
    WebWaitMessage1.Name := 'WebWaitMessage1';
    WebWaitMessage1.Left := 672;
    WebWaitMessage1.Top := 88;
    WebWaitMessage1.Width := 24;
    WebWaitMessage1.Height := 24;
    WebWaitMessage1.Opacity := 0.200000000000000000;
    WebWaitMessage1.Picture.LoadFromFile('dashboard.maintenance.gDashData.WebWaitMessage1.Picture.gif');
    wcYears.SetParentComponent(Self);
    wcYears.Name := 'wcYears';
    wcYears.Connection := dmData.dbConnect;
    wcYears.Left := 80;
    wcYears.Top := 80;
    wdsYears.SetParentComponent(Self);
    wdsYears.Name := 'wdsYears';
    wdsYears.AfterPost := wdsYearsAfterPost;
    wdsYears.Connection := dmData.dbConnect;
    wdsYears.Left := 80;
    wdsYears.Top := 144;
    wdsYearsSelected.SetParentComponent(wdsYears);
    wdsYearsSelected.Name := 'wdsYearsSelected';
    wdsYearsSelected.FieldName := 'Selected';
    wdsYearsYear.SetParentComponent(wdsYears);
    wdsYearsYear.Name := 'wdsYearsYear';
    wdsYearsYear.FieldName := 'Year';
    dsYears.SetParentComponent(Self);
    dsYears.Name := 'dsYears';
    dsYears.AutoEdit := False;
    dsYears.DataSet := wdsYears;
    dsYears.Left := 24;
    dsYears.Top := 152;
    wcMonths.SetParentComponent(Self);
    wcMonths.Name := 'wcMonths';
    wcMonths.Connection := dmData.dbConnect;
    wcMonths.Left := 177;
    wcMonths.Top := 88;
    wdsMonths.SetParentComponent(Self);
    wdsMonths.Name := 'wdsMonths';
    wdsMonths.AfterPost := wdsMonthsAfterPost;
    wdsMonths.Connection := dmData.dbConnect;
    wdsMonths.Left := 169;
    wdsMonths.Top := 176;
    wdsMonthsMonth.SetParentComponent(wdsMonths);
    wdsMonthsMonth.Name := 'wdsMonthsMonth';
    wdsMonthsMonth.FieldName := 'Month';
    wdsMonthsMonthName.SetParentComponent(wdsMonths);
    wdsMonthsMonthName.Name := 'wdsMonthsMonthName';
    wdsMonthsMonthName.FieldName := 'MonthName';
    wdsMonthsSelected.SetParentComponent(wdsMonths);
    wdsMonthsSelected.Name := 'wdsMonthsSelected';
    wdsMonthsSelected.FieldName := 'Selected';
    dsMonths.SetParentComponent(Self);
    dsMonths.Name := 'dsMonths';
    dsMonths.AutoEdit := False;
    dsMonths.DataSet := wdsMonths;
    dsMonths.Left := 241;
    dsMonths.Top := 144;
    wcReg.SetParentComponent(Self);
    wcReg.Name := 'wcReg';
    wcReg.Connection := dmData.dbConnect;
    wcReg.Left := 362;
    wcReg.Top := 88;
    wdsReg.SetParentComponent(Self);
    wdsReg.Name := 'wdsReg';
    wdsReg.Connection := dmData.dbConnect;
    wdsReg.Left := 394;
    wdsReg.Top := 144;
    wdsRegReg.SetParentComponent(wdsReg);
    wdsRegReg.Name := 'wdsRegReg';
    wdsRegReg.FieldName := 'Reg';
    wdsRegFleetNo.SetParentComponent(wdsReg);
    wdsRegFleetNo.Name := 'wdsRegFleetNo';
    wdsRegFleetNo.FieldName := 'FleetNo';
    wdsRegFleetType.SetParentComponent(wdsReg);
    wdsRegFleetType.Name := 'wdsRegFleetType';
    wdsRegFleetType.FieldName := 'FleetType';
    wdsRegSelected.SetParentComponent(wdsReg);
    wdsRegSelected.Name := 'wdsRegSelected';
    wdsRegSelected.FieldName := 'Selected';
    wdsRegPriKey.SetParentComponent(wdsReg);
    wdsRegPriKey.Name := 'wdsRegPriKey';
    wdsRegPriKey.FieldName := 'PriKey';
    dsReg.SetParentComponent(Self);
    dsReg.Name := 'dsReg';
    dsReg.AutoEdit := False;
    dsReg.DataSet := wdsReg;
    dsReg.Left := 450;
    dsReg.Top := 144;
    WebTimer1.SetParentComponent(Self);
    WebTimer1.Name := 'WebTimer1';
    WebTimer1.Enabled := False;
    SetEvent(WebTimer1, Self, 'OnTimer', 'WebTimer1Timer');
    WebTimer1.Left := 584;
    WebTimer1.Top := 313;
    wdsTempReg.SetParentComponent(Self);
    wdsTempReg.Name := 'wdsTempReg';
    wdsTempReg.Connection := dmData.dbConnect;
    wdsTempReg.Left := 514;
    wdsTempReg.Top := 104;
    StringField1.SetParentComponent(wdsTempReg);
    StringField1.Name := 'StringField1';
    StringField1.FieldName := 'Reg';
    StringField2.SetParentComponent(wdsTempReg);
    StringField2.Name := 'StringField2';
    StringField2.FieldName := 'FleetNo';
    StringField3.SetParentComponent(wdsTempReg);
    StringField3.Name := 'StringField3';
    StringField3.FieldName := 'FleetType';
    BooleanField1.SetParentComponent(wdsTempReg);
    BooleanField1.Name := 'BooleanField1';
    BooleanField1.FieldName := 'Selected';
    IntegerField1.SetParentComponent(wdsTempReg);
    IntegerField1.Name := 'IntegerField1';
    IntegerField1.FieldName := 'PriKey';
    dsSysTypes.SetParentComponent(Self);
    dsSysTypes.Name := 'dsSysTypes';
    dsSysTypes.AutoEdit := False;
    dsSysTypes.DataSet := wdsSysTypes;
    dsSysTypes.Left := 649;
    dsSysTypes.Top := 145;
    wcSysTypes.SetParentComponent(Self);
    wcSysTypes.Name := 'wcSysTypes';
    wcSysTypes.Connection := dmData.dbConnect;
    wcSysTypes.Left := 785;
    wcSysTypes.Top := 145;
    wdsSysTypes.SetParentComponent(Self);
    wdsSysTypes.Name := 'wdsSysTypes';
    wdsSysTypes.AfterPost := wdsSysTypesAfterPost;
    wdsSysTypes.Connection := dmData.dbConnect;
    wdsSysTypes.Left := 689;
    wdsSysTypes.Top := 81;
    wdsSysTypesSelected.SetParentComponent(wdsSysTypes);
    wdsSysTypesSelected.Name := 'wdsSysTypesSelected';
    wdsSysTypesSelected.FieldName := 'Selected';
    wdsSysTypesSysType.SetParentComponent(wdsSysTypes);
    wdsSysTypesSysType.Name := 'wdsSysTypesSysType';
    wdsSysTypesSysType.FieldName := 'SysType';
    wdsSysTypesDescription.SetParentComponent(wdsSysTypes);
    wdsSysTypesDescription.Name := 'wdsSysTypesDescription';
    wdsSysTypesDescription.FieldName := 'Description';
    wdsCostGroups.SetParentComponent(Self);
    wdsCostGroups.Name := 'wdsCostGroups';
    wdsCostGroups.AfterPost := wdsCostGroupsAfterPost;
    wdsCostGroups.Connection := dmData.dbConnect;
    wdsCostGroups.Left := 977;
    wdsCostGroups.Top := 72;
    wdsCostGroupsselected.SetParentComponent(wdsCostGroups);
    wdsCostGroupsselected.Name := 'wdsCostGroupsselected';
    wdsCostGroupsselected.FieldName := 'Selected';
    wdsCostGroupsCost.SetParentComponent(wdsCostGroups);
    wdsCostGroupsCost.Name := 'wdsCostGroupsCost';
    wdsCostGroupsCost.FieldName := 'Cost';
    wdsCostGroupsDescription.SetParentComponent(wdsCostGroups);
    wdsCostGroupsDescription.Name := 'wdsCostGroupsDescription';
    wdsCostGroupsDescription.FieldName := 'Description';
    dsCostGroups.SetParentComponent(Self);
    dsCostGroups.Name := 'dsCostGroups';
    dsCostGroups.DataSet := wdsCostGroups;
    dsCostGroups.Left := 937;
    dsCostGroups.Top := 144;
    wcCostGroups.SetParentComponent(Self);
    wcCostGroups.Name := 'wcCostGroups';
    wcCostGroups.Connection := dmData.dbConnect;
    wcCostGroups.Left := 1065;
    wcCostGroups.Top := 136;
    wdsDashboardSums.SetParentComponent(Self);
    wdsDashboardSums.Name := 'wdsDashboardSums';
    wdsDashboardSums.AfterOpen := wdsDashboardSumsAfterOpen;
    wdsDashboardSums.Connection := dmData.dbConnect;
    wdsDashboardSums.Left := 920;
    wdsDashboardSums.Top := 241;
    wdsDashboardSumsMaintenanceCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsMaintenanceCost.Name := 'wdsDashboardSumsMaintenanceCost';
    wdsDashboardSumsMaintenanceCost.FieldName := 'MaintenanceCost';
    wdsDashboardSumsTyreCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsTyreCost.Name := 'wdsDashboardSumsTyreCost';
    wdsDashboardSumsTyreCost.FieldName := 'TyreCost';
    wdsDashboardSumsWashCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsWashCost.Name := 'wdsDashboardSumsWashCost';
    wdsDashboardSumsWashCost.FieldName := 'WashCost';
    wdsDashboardSumsInsuranceCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsInsuranceCost.Name := 'wdsDashboardSumsInsuranceCost';
    wdsDashboardSumsInsuranceCost.FieldName := 'InsuranceCost';
    wdsDashboardSumsOtherCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsOtherCost.Name := 'wdsDashboardSumsOtherCost';
    wdsDashboardSumsOtherCost.FieldName := 'OtherCost';
    wdsDashboardSumsTotalCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsTotalCost.Name := 'wdsDashboardSumsTotalCost';
    wdsDashboardSumsTotalCost.FieldName := 'TotalCost';
    wdsDashboardSumsCapexCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsCapexCost.Name := 'wdsDashboardSumsCapexCost';
    wdsDashboardSumsCapexCost.FieldName := 'CapexCost';
    wdsDashboardSumsUnallCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsUnallCost.Name := 'wdsDashboardSumsUnallCost';
    wdsDashboardSumsUnallCost.FieldName := 'UnallCost';
    wdsDashboardSumsTotalCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsTotalCPK.Name := 'wdsDashboardSumsTotalCPK';
    wdsDashboardSumsTotalCPK.FieldName := 'TotalCPK';
    wdsDashboardSumsMaintenanceCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsMaintenanceCPK.Name := 'wdsDashboardSumsMaintenanceCPK';
    wdsDashboardSumsMaintenanceCPK.FieldName := 'MaintenanceCPK';
    wdsDashboardSumsTyreCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsTyreCPK.Name := 'wdsDashboardSumsTyreCPK';
    wdsDashboardSumsTyreCPK.FieldName := 'TyreCPK';
    wdsDashboardSumsWashCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsWashCPK.Name := 'wdsDashboardSumsWashCPK';
    wdsDashboardSumsWashCPK.FieldName := 'WashCPK';
    wdsDashboardSumsInsuranceCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsInsuranceCPK.Name := 'wdsDashboardSumsInsuranceCPK';
    wdsDashboardSumsInsuranceCPK.FieldName := 'InsuranceCPK';
    wdsDashboardSumsOtherCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsOtherCPK.Name := 'wdsDashboardSumsOtherCPK';
    wdsDashboardSumsOtherCPK.FieldName := 'OtherCPK';
    wdsDashboardSumsCapexCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsCapexCPK.Name := 'wdsDashboardSumsCapexCPK';
    wdsDashboardSumsCapexCPK.FieldName := 'CapexCPK';
    wdsDashboardSumsUnallCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsUnallCPK.Name := 'wdsDashboardSumsUnallCPK';
    wdsDashboardSumsUnallCPK.FieldName := 'UnallCPK';
    wdsDashboardSumsNotLinkedCost.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsNotLinkedCost.Name := 'wdsDashboardSumsNotLinkedCost';
    wdsDashboardSumsNotLinkedCost.FieldName := 'NotLinkedCost';
    wdsDashboardSumsNotLinkedCPK.SetParentComponent(wdsDashboardSums);
    wdsDashboardSumsNotLinkedCPK.Name := 'wdsDashboardSumsNotLinkedCPK';
    wdsDashboardSumsNotLinkedCPK.FieldName := 'NotLinkedCPK';
    wdsDashData.SetParentComponent(Self);
    wdsDashData.Name := 'wdsDashData';
    wdsDashData.AfterOpen := wdsDashDataAfterOpen;
    wdsDashData.Connection := dmData.dbConnect;
    wdsDashData.Left := 312;
    wdsDashData.Top := 400;
    wdsDashDataJobcardNo.SetParentComponent(wdsDashData);
    wdsDashDataJobcardNo.Name := 'wdsDashDataJobcardNo';
    wdsDashDataJobcardNo.FieldName := 'JobcardNo';
    wdsDashDataStockDescription.SetParentComponent(wdsDashData);
    wdsDashDataStockDescription.Name := 'wdsDashDataStockDescription';
    wdsDashDataStockDescription.FieldName := 'StockDescription';
    wdsDashDataTotalExcl.SetParentComponent(wdsDashData);
    wdsDashDataTotalExcl.Name := 'wdsDashDataTotalExcl';
    wdsDashDataTotalExcl.FieldName := 'TotalExcl';
    wdsDashDataGlCode.SetParentComponent(wdsDashData);
    wdsDashDataGlCode.Name := 'wdsDashDataGlCode';
    wdsDashDataGlCode.FieldName := 'GlCode';
    wdsDashDataReason.SetParentComponent(wdsDashData);
    wdsDashDataReason.Name := 'wdsDashDataReason';
    wdsDashDataReason.FieldName := 'Reason';
    wdsDashDataCategory.SetParentComponent(wdsDashData);
    wdsDashDataCategory.Name := 'wdsDashDataCategory';
    wdsDashDataCategory.FieldName := 'Category';
    wdsDashDataRepMain.SetParentComponent(wdsDashData);
    wdsDashDataRepMain.Name := 'wdsDashDataRepMain';
    wdsDashDataRepMain.FieldName := 'RepMain';
    wdsDashDataCostDescription.SetParentComponent(wdsDashData);
    wdsDashDataCostDescription.Name := 'wdsDashDataCostDescription';
    wdsDashDataCostDescription.FieldName := 'CostDescription';
    wdsDashDataTRegNo.SetParentComponent(wdsDashData);
    wdsDashDataTRegNo.Name := 'wdsDashDataTRegNo';
    wdsDashDataTRegNo.FieldName := 'TRegNo';
    wdsDashDataTFleetNo.SetParentComponent(wdsDashData);
    wdsDashDataTFleetNo.Name := 'wdsDashDataTFleetNo';
    wdsDashDataTFleetNo.FieldName := 'TFleetNo';
    wdsDashDataOrderNo.SetParentComponent(wdsDashData);
    wdsDashDataOrderNo.Name := 'wdsDashDataOrderNo';
    wdsDashDataOrderNo.FieldName := 'OrderNo';
    wdsDashDataJobDate.SetParentComponent(wdsDashData);
    wdsDashDataJobDate.Name := 'wdsDashDataJobDate';
    wdsDashDataJobDate.FieldName := 'JobDate';
    wdsDashDataReferenceNo.SetParentComponent(wdsDashData);
    wdsDashDataReferenceNo.Name := 'wdsDashDataReferenceNo';
    wdsDashDataReferenceNo.FieldName := 'ReferenceNo';
    wdsDashDataVehType.SetParentComponent(wdsDashData);
    wdsDashDataVehType.Name := 'wdsDashDataVehType';
    wdsDashDataVehType.FieldName := 'Vehtype';
    wdsDashDataJobType.SetParentComponent(wdsDashData);
    wdsDashDataJobType.Name := 'wdsDashDataJobType';
    wdsDashDataJobType.FieldName := 'JobType';
    wdsDashDataSupplier.SetParentComponent(wdsDashData);
    wdsDashDataSupplier.Name := 'wdsDashDataSupplier';
    wdsDashDataSupplier.FieldName := 'Supplier';
    wcDashboardSums.SetParentComponent(Self);
    wcDashboardSums.Name := 'wcDashboardSums';
    wcDashboardSums.Connection := dmData.dbConnect;
    wcDashboardSums.Left := 792;
    wcDashboardSums.Top := 249;
    dsDashBoardSums.SetParentComponent(Self);
    dsDashBoardSums.Name := 'dsDashBoardSums';
    dsDashBoardSums.DataSet := wdsDashboardSums;
    dsDashBoardSums.Left := 1080;
    dsDashBoardSums.Top := 241;
    wcDashData.SetParentComponent(Self);
    wcDashData.Name := 'wcDashData';
    wcDashData.Connection := dmData.dbConnect;
    wcDashData.Left := 280;
    wcDashData.Top := 344;
    dsDashData.SetParentComponent(Self);
    dsDashData.Name := 'dsDashData';
    dsDashData.DataSet := wdsDashData;
    dsDashData.Left := 184;
    dsDashData.Top := 400;
  finally
    pTop.AfterLoadDFMValues;
    pBottom.AfterLoadDFMValues;
    pMain.AfterLoadDFMValues;
    pMainTop.AfterLoadDFMValues;
    pMainMonths.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    gMonths.AfterLoadDFMValues;
    gdaMonths.AfterLoadDFMValues;
    btnMonthsClear.AfterLoadDFMValues;
    pMainYears.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    gYears.AfterLoadDFMValues;
    gdaYears.AfterLoadDFMValues;
    btnYearsClear.AfterLoadDFMValues;
    pRegNo.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    btnRegClear.AfterLoadDFMValues;
    gReg.AfterLoadDFMValues;
    gdaReg.AfterLoadDFMValues;
    pMaintTypes.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    gSysTypes.AfterLoadDFMValues;
    gdaSysTypes.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    pCostGroups.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    gCostGroups.AfterLoadDFMValues;
    gdaCostGroups.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    wpDashSums.AfterLoadDFMValues;
    wpTotalCost.AfterLoadDFMValues;
    WebDBLabel1.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebDBLabel10.AfterLoadDFMValues;
    wpMaintenance.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebDBLabel2.AfterLoadDFMValues;
    WebDBLabel11.AfterLoadDFMValues;
    wpTyres.AfterLoadDFMValues;
    WebDBLabel5.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebDBLabel12.AfterLoadDFMValues;
    wpCost.AfterLoadDFMValues;
    WebDBLabel3.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebDBLabel9.AfterLoadDFMValues;
    wpInsurance.AfterLoadDFMValues;
    WebDBLabel4.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebDBLabel13.AfterLoadDFMValues;
    wpOperational.AfterLoadDFMValues;
    WebDBLabel6.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebDBLabel14.AfterLoadDFMValues;
    wbSearch.AfterLoadDFMValues;
    wpCapex.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebDBLabel7.AfterLoadDFMValues;
    WebDBLabel15.AfterLoadDFMValues;
    wpUnAll.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebDBLabel8.AfterLoadDFMValues;
    WebDBLabel16.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    wbExcel.AfterLoadDFMValues;
    wpNoLink.AfterLoadDFMValues;
    WebLabel17.AfterLoadDFMValues;
    WebDBLabel17.AfterLoadDFMValues;
    WebDBLabel18.AfterLoadDFMValues;
    pDashData.AfterLoadDFMValues;
    gDashData.AfterLoadDFMValues;
    gdaDashData.AfterLoadDFMValues;
    WebWaitMessage1.AfterLoadDFMValues;
    wcYears.AfterLoadDFMValues;
    wdsYears.AfterLoadDFMValues;
    wdsYearsSelected.AfterLoadDFMValues;
    wdsYearsYear.AfterLoadDFMValues;
    dsYears.AfterLoadDFMValues;
    wcMonths.AfterLoadDFMValues;
    wdsMonths.AfterLoadDFMValues;
    wdsMonthsMonth.AfterLoadDFMValues;
    wdsMonthsMonthName.AfterLoadDFMValues;
    wdsMonthsSelected.AfterLoadDFMValues;
    dsMonths.AfterLoadDFMValues;
    wcReg.AfterLoadDFMValues;
    wdsReg.AfterLoadDFMValues;
    wdsRegReg.AfterLoadDFMValues;
    wdsRegFleetNo.AfterLoadDFMValues;
    wdsRegFleetType.AfterLoadDFMValues;
    wdsRegSelected.AfterLoadDFMValues;
    wdsRegPriKey.AfterLoadDFMValues;
    dsReg.AfterLoadDFMValues;
    WebTimer1.AfterLoadDFMValues;
    wdsTempReg.AfterLoadDFMValues;
    StringField1.AfterLoadDFMValues;
    StringField2.AfterLoadDFMValues;
    StringField3.AfterLoadDFMValues;
    BooleanField1.AfterLoadDFMValues;
    IntegerField1.AfterLoadDFMValues;
    dsSysTypes.AfterLoadDFMValues;
    wcSysTypes.AfterLoadDFMValues;
    wdsSysTypes.AfterLoadDFMValues;
    wdsSysTypesSelected.AfterLoadDFMValues;
    wdsSysTypesSysType.AfterLoadDFMValues;
    wdsSysTypesDescription.AfterLoadDFMValues;
    wdsCostGroups.AfterLoadDFMValues;
    wdsCostGroupsselected.AfterLoadDFMValues;
    wdsCostGroupsCost.AfterLoadDFMValues;
    wdsCostGroupsDescription.AfterLoadDFMValues;
    dsCostGroups.AfterLoadDFMValues;
    wcCostGroups.AfterLoadDFMValues;
    wdsDashboardSums.AfterLoadDFMValues;
    wdsDashboardSumsMaintenanceCost.AfterLoadDFMValues;
    wdsDashboardSumsTyreCost.AfterLoadDFMValues;
    wdsDashboardSumsWashCost.AfterLoadDFMValues;
    wdsDashboardSumsInsuranceCost.AfterLoadDFMValues;
    wdsDashboardSumsOtherCost.AfterLoadDFMValues;
    wdsDashboardSumsTotalCost.AfterLoadDFMValues;
    wdsDashboardSumsCapexCost.AfterLoadDFMValues;
    wdsDashboardSumsUnallCost.AfterLoadDFMValues;
    wdsDashboardSumsTotalCPK.AfterLoadDFMValues;
    wdsDashboardSumsMaintenanceCPK.AfterLoadDFMValues;
    wdsDashboardSumsTyreCPK.AfterLoadDFMValues;
    wdsDashboardSumsWashCPK.AfterLoadDFMValues;
    wdsDashboardSumsInsuranceCPK.AfterLoadDFMValues;
    wdsDashboardSumsOtherCPK.AfterLoadDFMValues;
    wdsDashboardSumsCapexCPK.AfterLoadDFMValues;
    wdsDashboardSumsUnallCPK.AfterLoadDFMValues;
    wdsDashboardSumsNotLinkedCost.AfterLoadDFMValues;
    wdsDashboardSumsNotLinkedCPK.AfterLoadDFMValues;
    wdsDashData.AfterLoadDFMValues;
    wdsDashDataJobcardNo.AfterLoadDFMValues;
    wdsDashDataStockDescription.AfterLoadDFMValues;
    wdsDashDataTotalExcl.AfterLoadDFMValues;
    wdsDashDataGlCode.AfterLoadDFMValues;
    wdsDashDataReason.AfterLoadDFMValues;
    wdsDashDataCategory.AfterLoadDFMValues;
    wdsDashDataRepMain.AfterLoadDFMValues;
    wdsDashDataCostDescription.AfterLoadDFMValues;
    wdsDashDataTRegNo.AfterLoadDFMValues;
    wdsDashDataTFleetNo.AfterLoadDFMValues;
    wdsDashDataOrderNo.AfterLoadDFMValues;
    wdsDashDataJobDate.AfterLoadDFMValues;
    wdsDashDataReferenceNo.AfterLoadDFMValues;
    wdsDashDataVehType.AfterLoadDFMValues;
    wdsDashDataJobType.AfterLoadDFMValues;
    wdsDashDataSupplier.AfterLoadDFMValues;
    wcDashboardSums.AfterLoadDFMValues;
    dsDashBoardSums.AfterLoadDFMValues;
    wcDashData.AfterLoadDFMValues;
    dsDashData.AfterLoadDFMValues;
  end;
end;

end.
